// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T18:29:32.479Z
// Property: Jackstraw Apartments (ID: 6767906449166986)
// Collections: 42 amenities, 45 floorplans (live), 64 photos, 79 POIs, 5 reviews, 8 virtual tours, 7 office hours, 1 special offers (live), 2 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162273",
  "multihub_property_id": "6767906449166986",
  "property_external_id": "9m38r85",
  "property_zillow_url": "https://www.zillow.com/apartments/bend-or/jackstraw/CnBp94/",
  "property_apartments_url": "https://www.apartments.com/jackstraw-bend-or/9m38r85/",
  "property_google_business_url": "https://www.google.com/maps/place/Jackstraw/data=!4m2!3m1!1s0x0:0x1bbe21bf98185408?sa=X&ved=2ahUKEwi49K_r2riSAxV2-DgGHVu1BZ8Q_BJ6BAhLEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "jackstraw-apartments",
  "property_name": "Jackstraw Apartments",
  "property_website_url": "https://www.jackstrawbend.com/",
  "property_domain": null,
  "property_address": "310 SW Industrial Way",
  "property_full_address": "310 SW Industrial Way, Bend, OR 97702",
  "property_address_1": "310 SW Industrial Way",
  "property_address_2": null,
  "property_address_city": "Bend",
  "property_address_state": "OR",
  "property_address_zip_full": null,
  "property_address_zip": "97702",
  "property_address_country": "US",
  "property_address_county": "Deschutes County",
  "property_neighborhood_address": "Southern Crossing",
  "property_address_latitude": "44.0513262",
  "property_address_longitude": "-121.3119397",
  "property_email": null,
  "property_phone": "(541) 317-2857",
  "property_call_tracking_phone": null,
  "property_company_name": "Repli Sandbox",
  "property_company_url": "testurl.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Bend is right outside your door at Jackstraw Apartments.</strong> Explore light-filled studio to three-bedroom and townhome-style layouts with polished finishes, thoughtful storage, and a connected Southern Crossing setting built for the best of Central Oregon.</p>",
  "property_long_description": "<p><strong>At Jackstraw Apartments, Bend is right outside your door.</strong> Set in Southern Crossing between downtown and the Old Mill District, this mixed-use address puts you beside the Box Factory, moments from Sisters Coffee, Market of Choice, riverfront dining, local shops, and the Deschutes River Trail’s Old Mill Reach.</p><p>Inside, choose from smart studios, one-, two-, and three-bedroom apartments, plus townhome-style layouts, all designed with light, air, and storage in mind. Explore <a href=\"/floor-plans\">available floor plans</a> with quartz countertops, stainless steel appliances, in-home laundry, custom closets, MERV-13 filtration, air conditioning, bike racks, and select Cascade Mountain views or private outdoor space.</p><p>Your days can flow from the double-height fitness center to private offices, conference rooms, the fifth-floor Sunset Lounge, courtyards, pet spa, gear storage, package room, and 60+ EV chargers. With Fitwel-certified design, local art, drought-tolerant landscaping, and easy access to Hayden Homes Amphitheater, Farewell Bend Park, and downtown Bend, Jackstraw gives you a polished home base for the best of Central Oregon.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-385e-712e-b782-f79132bcb078.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of a modern apartment complex surrounded by trees and mountains.",
    "public_id": "019cfde3-385e-712e-b782-f79132bcb078",
    "storage_key": "property/6767906449166986/019cfde3-385e-712e-b782-f79132bcb078.webp",
    "width": 1920,
    "height": 969
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "313",
  "property_year_built": "2025",
  "property_year_renovated": null,
  "property_walk_score": "79",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "39.29712460063898",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": "400",
  "property_monthly_pet_rent": "40",
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "We welcome cats and dogs with no breed or weight restrictions.",
  "property_pet_policy_description": "We welcome cats and dogs with no breed or weight restrictions. Pet deposit: $400. Monthly pet rent: $40. Maximum number of pets per unit: not specified.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-0e68-72b9-a201-030182e29929.webp",
  "property_primary_logo_media": {
    "alt_text": "JACKSTRAW logo in white stencil font on black background",
    "public_id": "019cfde3-0e68-72b9-a201-030182e29929",
    "storage_key": "property/6767906449166986/019cfde3-0e68-72b9-a201-030182e29929.webp",
    "width": 1920,
    "height": 253
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-0e68-72b9-a201-030182e29929.webp",
  "property_mono_white_logo_media": {
    "alt_text": "JACKSTRAW logo in white stencil font on black background",
    "public_id": "019cfde3-0e68-72b9-a201-030182e29929",
    "storage_key": "property/6767906449166986/019cfde3-0e68-72b9-a201-030182e29929.webp",
    "width": 1920,
    "height": 253
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde6-7dd1-730c-ad26-f46f8a693039.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Jackstraw logo",
    "public_id": "019cfde6-7dd1-730c-ad26-f46f8a693039",
    "storage_key": "property/6767906449166986/019cfde6-7dd1-730c-ad26-f46f8a693039.webp",
    "width": 640,
    "height": 84
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019cfdd9-c8a4-71d3-8bff-111ee22aee5d.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
  "property_company_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2713-d4f5-701a-91f4-9c4e82dc6c6b",
    "storage_key": "company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2705-ea93-721c-8d4f-e2d2a439a839",
    "storage_key": "company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#763737",
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 3",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "358 - 10,181,064 sq ft",
  "property_sqft_min": "358",
  "property_sqft_max": "10,181,064",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 190,
  "property_facebook_url": "https://www.facebook.com/CentralOregonDaily/posts/your-first-look-inside-jackstraw-the-jackstraw-near-bends-box-factory-is-officia/1450111540454222/",
  "property_instagram_url": "https://www.instagram.com/popular/jackstraw-apartments-bend-oregon/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJp_ul2sPHuFQRCFQYmL8hvhs",
  "property_youtube_url": "https://www.youtube.com/watch?v=fhYVkrMny60",
  "property_yelp_url": "https://www.yelp.com/biz/jackstraw-bend",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Jackstraw Apartments",
  "property_home_romance_title": "Embrace the Joy of Living in Your New Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Amenities that work harder.</strong> Jackstraw brings Bend routines into focus with 60+ EV charging stations, secure gear storage with bike support, package service, on-site retail, private offices, and conference rooms. Reset in the double-height fitness center, fifth-floor Sunset Lounge, landscaped courtyards, or pet spa. At home, floor-to-ceiling windows, air conditioning, MERV-13 filtration, in-home laundry, quartz surfaces, stainless steel appliances, and bike racks in every residence make comfort feel built in.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find the Jackstraw layout that clicks.</strong> Compare studio, one-, two-, and three-bedroom apartments in Bend, including townhome-style options, with current availability and transparent pricing.</p><p>Floor-to-ceiling windows, quartz countertops, stainless steel appliances, in-home laundry, custom closets, air conditioning, MERV-13 filtration, and built-in bike storage make each home work beautifully. Select layouts add private outdoor space, mountain views, or built-in shelving, with three finish schemes to match your style.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture Jackstraw in focus.</strong> Browse floor-to-ceiling windows, quartz kitchens with tile backsplashes, warm bedrooms with smart storage, and shared spaces designed with polish—from co-working nooks and a fitness center to garden-framed courtyard seating and the fifth-floor Sunset Lounge with Cascade views.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Start with the map, then step outside.</strong> Jackstraw sits in Southern Crossing’s energetic seam, where Bend’s maker spirit meets river paths, patios, and performance nights. Wander Lava Pass to Box Factory shops, catch the food-cart scene at The Podski, or follow the Deschutes River Trail toward Riverbend Park and Bend Whitewater Park. Explore the neighborhood, then see how central Bend feels from your front door.</p>",
  "property_home_reviews_blurb": "<p><strong>See what stands out at Jackstraw Apartments.</strong> Reviews highlight modern, clean apartments with thoughtful layouts, natural light, polished finishes, and “<strong>luxury quality throughout</strong>.” Residents also point to knowledgeable leasing support, responsive maintenance, comfortable community spaces, mountain-view lounges, a well-liked fitness area, and a convenient Southern Crossing location.</p>",
  "property_neighborhood_blurb": "<p><strong>Start with the map, then step outside.</strong> Jackstraw puts you in Southern Crossing’s most energetic seam, where Bend’s maker spirit, river paths, patios, and performance nights shape the day. Wander Lava Pass toward Box Factory shops, meet the food-cart scene at The Podski, or follow the Deschutes River Trail to Riverbend Park, Bend Whitewater Park, and long views along the water.</p><p>Here, errands, coffee runs, concerts, trail time, and dinner reservations can all feel naturally connected. Explore nearby favorites on the interactive map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how this central Bend neighborhood feels from your front door.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that do more than fill a checklist.</strong> At Jackstraw Apartments, daily essentials feel considered from the moment you arrive: 60+ EV charging stations, secure gear storage with bike support, package service, and on-site retail keep routines simple in Bend. When it’s time to focus, settle into a private office or conference room; when it’s time to reset, move from the double-height fitness center to the fifth-floor Sunset Lounge, landscaped courtyards, or pet spa.</p><p>Inside, floor-to-ceiling windows, air conditioning, MERV-13 filtration, in-home laundry, custom closets, quartz surfaces, stainless steel appliances, and bike racks in every home make comfort feel built in. Fitwel certification, pollinator gardens, and LEED for Homes Platinum design add a healthier, more forward-looking layer to the experience. See more in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Start your Jackstraw application online.</strong><br>Choose from smart studios, one-, two-, and three-bedroom apartments, plus townhome-style layouts in a polished Bend setting designed for light, air, and storage. With thoughtful finishes, work and wellness spaces, and everyday conveniences close at hand, your next home base is ready when you are.</p>",
  "property_contactus_blurb": "<p><strong>Questions about Jackstraw Apartments?</strong> Our leasing team is here to help with availability, floor plans, community details, or directions to our Southern Crossing address between downtown Bend and the Old Mill District. Reach out today and let us point you toward your next step.</p>",
  "property_faqs_blurb": "<p><strong>Have questions about Jackstraw?</strong> Start here for quick answers about the community, leasing, floor plans, amenities, and day-to-day living in this Southern Crossing address. If you need anything more specific, the leasing team is happy to help you find the right next step.</p>",
  "property_floorplans_blurb": "<p><strong>Find the Jackstraw layout that clicks.</strong> Browse studio, one-, two-, and three-bedroom apartments in Bend, including townhome-style options, with current availability and transparent monthly pricing shown as you compare.</p><p>Inside, each home is designed to make everyday space work harder: <strong>floor-to-ceiling windows</strong> bring in natural light, quartz countertops and stainless steel appliances sharpen the kitchen, and in-home laundry, custom closets, air conditioning, MERV-13 filtration, and built-in bike storage add practical ease. Select layouts offer private outdoor space, mountain views, or built-in shelving, while three finish schemes let you choose a look that feels right. Explore the cards below, view more <a href=\"/amenities\">apartment features</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite floor plan in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture Jackstraw in focus.</strong> Browse the gallery for the textures and sightlines that make this Bend address feel polished: floor-to-ceiling windows catching afternoon light, sleek kitchens with quartz counters and tile backsplashes, and calm bedrooms shaped by warm finishes and smart storage.</p><p>Then move through the shared spaces on screen: an art-forward lobby with co-working nooks, a fitness center ready for your next routine, courtyard seating framed by gardens, and the fifth-floor Sunset Lounge opening toward Cascade views. You’ll also spot thoughtful everyday details, from in-home bike racks to select balconies that extend the view outdoors. Like what you see? Continue with <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Jackstraw on the map below.</strong><br>See available apartments in Southern Crossing, then zoom out to the Bend spots that shape daily life here—from downtown and the Old Mill District to the Box Factory and Deschutes River Trail nearby.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, whiskers, and Bend days outside.</strong> At Jackstraw Apartments, cats and dogs are welcome without breed or weight restrictions, so your search can focus on the home itself—not fine print. After muddy trail walks or rainy courtyard laps, rinse off at the <a href=\"/amenities\">premium pet spa</a>, then head upstairs to a light-filled apartment with in-home laundry, air conditioning, and storage that helps keep leashes, toys, and gear organized.</p><p>For daily fresh air, landscaped outdoor spaces and nearby river-connected paths make quick walks feel easy, while official off-leash areas give dogs room to run when it’s time for more play. Have a pet-policy question before you visit? <a href=\"/contact-us\">Contact the leasing team</a> or bring your four-legged roommate along for a tour.</p>",
  "property_referafriend_blurb": "<p><strong>Share Jackstraw with a friend.</strong> If you love having Bend right outside your door, smart apartment designs, light-filled spaces, and polished community perks from work areas to the Sunset Lounge, invite a friend to see what makes Jackstraw a standout home base in Southern Crossing.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Jackstraw Apartments.</strong><br>Pay rent, submit maintenance requests, and manage your account from one convenient place—so your home base in Bend stays as seamless as the light-filled apartments, thoughtful storage, and polished community spaces around you.</p>",
  "property_reviews_blurb": "<p><strong>See what stands out at Jackstraw Apartments.</strong> As you read through the reviews, you’ll notice the same themes again and again: modern, clean apartments; thoughtful layouts; natural light; polished finishes; and community spaces that feel comfortable, useful, and well cared for.</p><p>Reviewers also call out the people behind the experience, from knowledgeable leasing support to friendly, responsive maintenance. Add in a convenient Southern Crossing setting, mountain-view lounge spaces, a well-liked fitness area, and the sense that everything feels “<strong>luxury quality throughout</strong>,” and it’s easy to see why Jackstraw earns such enthusiastic feedback.</p>",
  "property_created_at": "1768250613419",
  "property_scheduletour_blurb": "<p><strong>See Jackstraw in person.</strong> Tour light-filled layouts with smart storage, quartz finishes, in-home laundry, and the polished community spaces that make this Bend address feel connected from the moment you arrive. Schedule your visit and picture your day-to-day here.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>The Jackstraw leasing team will be in touch soon. In the meantime, picture a polished Bend home base with light-filled layouts, thoughtful storage, elevated finishes, and everyday access to the best of Southern Crossing, downtown, and the Old Mill District.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you stop by.</strong> Jackstraw’s virtual tours let you move at your own pace through the spaces that matter most, from the polished lobby and community areas to apartment interiors with clean modern finishes, bright windows, smart storage, and open kitchens. Explore one-bedroom apartment tours, compare the feel of additional apartment walkthroughs, or take a closer look at a three-bedroom layout with room to spread out. You can pause on details, revisit favorite angles, and narrow your next move from wherever you are.</p><p>When you’re ready to go beyond the screen, browse current <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Jackstraw Apartments in Bend in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Jackstraw Apartments",
  "property_seo_title_home": "Jackstraw Apartments |  Apartments in Bend, OR",
  "property_seo_description_home": "Experience Jackstraw Apartments in Bend, OR—where stunning Cascade views meet modern amenities. Choose your style and find your new home, tailored for you!",
  "property_seo_title_floorplans": "Floor Plans | Bend, OR Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Jackstraw Apartments in Bend, OR! From cozy studios to spacious three-bedroom layouts, browse all our unique floor plans today!",
  "property_seo_title_amenities": "Amenities | Bend, OR Apartments for Rent",
  "property_seo_description_amenities": "Experience life at Jackstraw Apartments in Bend, OR! Enjoy stunning Cascade Mountain views, modern amenities, and flexible floor plans. Live your best life!",
  "property_seo_title_gallery": "Gallery | Apartments in Bend, OR",
  "property_seo_description_gallery": "Discover Bend living at Jackstraw Apartments! Unique layouts, mountain views, and modern amenities await. Envision your new home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Jackstraw Apartments Apartments",
  "property_seo_description_virtualtours": "Immerse yourself in the charm of Jackstraw Apartments in Bend, OR. Take a virtual tour and find your perfect studio, one, two, or three-bedroom home today!",
  "property_seo_title_interactivemap": "Interactive Map | Jackstraw Apartments Apartments",
  "property_seo_description_interactivemap": "Find your dream apartment at Jackstraw Apartments in Bend, OR! Explore stylish studio to three-bedroom layouts, fantastic amenities, and serene mountain views.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Bend, OR",
  "property_seo_description_neighborhood": "Live the Bend lifestyle at Jackstraw Apartments! Uncover local gems, vibrant eateries, and serene parks just steps from your future home.",
  "property_seo_title_contact": "Contact Us | Jackstraw Apartments",
  "property_seo_description_contact": "Discover comfortable living at Jackstraw Apartments, Bend, OR! From studios to three bedrooms, our leasing team is here to help—contact us today!",
  "property_seo_title_faqs": "FAQs | Apartments in Bend, OR",
  "property_seo_description_faqs": "Find answers to your FAQs about Jackstraw Apartments in Bend, OR. From amenities to floor plans, explore all you need to know about your future home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Bend, OR",
  "property_seo_description_reviews": "Experience life at Jackstraw Apartments in Bend, OR! Hear from our residents about modern amenities, stunning views, and a vibrant community atmosphere.",
  "property_seo_title_applynow": "Apply Now | Apartments in Bend, OR",
  "property_seo_description_applynow": "Discover Jackstraw Apartments in Bend, OR! Enjoy Cascade Mountain views, modern amenities, and stylish layouts. Your new home awaits!",
  "property_seo_title_residentaccess": "Resident Access | Jackstraw Apartments",
  "property_seo_description_residentaccess": "Experience convenience at Jackstraw Apartments, Bend, OR! Use your resident portal for rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Jackstraw Apartments",
  "property_seo_description_referafriend": "Refer a friend to Jackstraw Apartments in Bend, OR! Great friends make great neighbors. Share the lifestyle and create lasting memories together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Jackstraw Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Jackstraw Apartments in Bend, OR. Schedule your tour today and find your perfect blend of comfort and style!",
  "property_seo_title_privacy": "Privacy Policy | Jackstraw Apartments",
  "property_seo_description_privacy": "At Jackstraw Apartments in Bend, OR, your privacy matters. Read our policy to see how we protect your personal information and enhance your living experience.",
  "property_seo_title_accessibility": "Website Accessibility | Jackstraw Apartments",
  "property_seo_description_accessibility": "At Jackstraw Apartments in Bend, OR, we prioritize accessibility for all residents. Join a community where everyone feels at home and celebrated!",
  "property_seo_title_sitemap": "Sitemap | Jackstraw Apartments",
  "property_seo_description_sitemap": "Uncover the essence of Jackstraw Apartments in Bend, OR. Navigate our sitemap for a seamless journey through our vibrant community and available amenities.",
  "property_seo_title_thankyou": "Thank You | Jackstraw Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! At Jackstraw Apartments in Bend, OR, your new home awaits. Expect a prompt reply from our dedicated team soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Bend, OR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1778693679166",
  "amenities": [
    {
      "id": "ec_a7ea0761dd2d45043816252f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_08cd0a35f07ca1f699896360",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "On-Site Retail",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f2399127ba2d9a297d61d48c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Package Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e820dafb738abb22ac785779",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Car Charging Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d173c40fd1eb93e20ceedaf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Washing Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_133780433043fd17b0a79341",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e846544c949df6669a3a5e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Conference Rooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_890308e5cfaba48ec9881f68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5c3d3990b30dd1ef046b1c28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_efcbd49a51d33ee43c432195",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7c944451efd50bbff3d2e9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa5fec1742f3a2cba396c78a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "60+ EV chargers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_57499567a986806ba5cee4f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning for Superior Indoor Quality",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6184f413a38c61e7bb386434",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Bike Racks in Every Home",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51d416f233086db340bd99a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Breathe Easy with Merv-13 Filters",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_385a3ad1e6883376b8c4bf91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Cascade Mountain Views*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ef7b77c12562cd1aa09175ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Choose Your Style with Three Color Schemes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4bcf282c6e73a2ef983d3f74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Club Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bcaf381f5786557cc7ece929",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Custom Closets with Extra Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fe7d085fe2a1b41afc85f3b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Easy Set Up Low-Cost Wifi in Every Home",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d675ad872fde15a914bd3daf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitwel Certfied",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0db717f2de0f8cae9df075ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "In-Home Washer and Dryer",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09969b928e7e5f19abc17cd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "On-site Pollinator Program of Honeybee Hotels",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5d0b7ffb79d8e012127986ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Private Offices for Quiet Chats",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d94c880e3b33e3a69ec636c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Private Patios and Balconies*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7c23c1c0f63868ce041dcf9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Quartz Countertops with Tile Backsplash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_98fee84d037855d0c41ed302",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Unique Built-in Shelves in Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_601f62c976e2ab7e7b6786db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1909872ab2268202aad59fa4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d7685c7a769616b467cf5d3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df97ca5caf1a557e59e26c7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f8897b89c50c7acfd9bbaf34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1ead8d0661929edf6852cbf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc2a536d5491d9abc3ed31cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1308d7ff4b7efb01a81ce839",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e789d8b707edd4005722b44f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9c302c112ba19905f5e8699f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d400a240f0ce6613e502f4c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a579ccb30cd17bd2593bef4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a64191f7bce74bc3a4ceb78a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Freezer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_baf3245b7f01694a8fc1cc21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Large Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_62498916d69972ae2c550d82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "external_id": "false",
      "title": "Floor to Ceiling Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_c1538abac791fd5a4c4ccbb1",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-0e68-72b9-a201-030182e29929.webp",
      "image_media": {
        "alt_text": "Jackstraw wordmark logo.",
        "public_id": "019cfde3-0e68-72b9-a201-030182e29929",
        "storage_key": "property/6767906449166986/019cfde3-0e68-72b9-a201-030182e29929.webp",
        "width": 1920,
        "height": 253
      },
      "title": "Logo",
      "description": "Brand logo for Jackstraw property branding used in marketing materials.",
      "link": "false",
      "alt_text": "Jackstraw wordmark logo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/7f198d9d/dms3rep/multi/opt/Updated_Jackstraw_White_Logo_Horiz-1920w.png"
    },
    {
      "id": "ec_014d4e10f64e1a5d9cd33c95",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-0e68-72b9-a201-070fbe222ed7.webp",
      "image_media": {
        "alt_text": "Contemporary living room with wall sculpture, vinyl setup, and glass door to sunlit balcony.",
        "public_id": "019cfde3-0e68-72b9-a201-070fbe222ed7",
        "storage_key": "property/6767906449166986/019cfde3-0e68-72b9-a201-070fbe222ed7.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Community",
      "description": "Modern apartment interior with a listening station, wood shelving, and a bright, open living area.",
      "link": "false",
      "alt_text": "Contemporary living room with wall sculpture, vinyl setup, and glass door to sunlit balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/41-web-or-mls-Riley+Visuals-41.jpg"
    },
    {
      "id": "ec_a822033f8d489dcd75fe8e39",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-0e3b-77bd-b729-c6f54b5b5dbc.webp",
      "image_media": {
        "alt_text": "Bright communal dining area with a long table, chairs, and floor-to-ceiling windows.",
        "public_id": "019cfde3-0e3b-77bd-b729-c6f54b5b5dbc",
        "storage_key": "property/6767906449166986/019cfde3-0e3b-77bd-b729-c6f54b5b5dbc.webp",
        "width": 1920,
        "height": 1781
      },
      "title": "Apartment",
      "description": "Bright communal dining area with expansive windows, warm wood ceiling, and a long table for group gatherings.",
      "link": "false",
      "alt_text": "Bright communal dining area with a long table, chairs, and floor-to-ceiling windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/Jackstraw-JoshPartee-5027.jpg"
    },
    {
      "id": "ec_6de340a0f68de53823692e17",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-0e68-72b9-a201-0a04c0339784.webp",
      "image_media": {
        "alt_text": "Inside a modern community gym with weight racks, barbells, and kettlebells.",
        "public_id": "019cfde3-0e68-72b9-a201-0a04c0339784",
        "storage_key": "property/6767906449166986/019cfde3-0e68-72b9-a201-0a04c0339784.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Community",
      "description": "On-site fitness center with a squat rack, free weights, kettlebells, medicine balls, and a storage rack for workouts.",
      "link": "false",
      "alt_text": "Inside a modern community gym with weight racks, barbells, and kettlebells.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/26-web-or-mls-Riley+Visuals-26+%281%29.jpg"
    },
    {
      "id": "ec_5349bc0996103f88de9f1f4c",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-1b27-70bc-a3b8-35e73199f1c1.webp",
      "image_media": {
        "alt_text": "Bright gym interior with treadmills, weight racks, and large windows.",
        "public_id": "019cfde3-1b27-70bc-a3b8-35e73199f1c1",
        "storage_key": "property/6767906449166986/019cfde3-1b27-70bc-a3b8-35e73199f1c1.webp",
        "width": 1920,
        "height": 1682
      },
      "title": "Community",
      "description": "On-site fitness center at a multifamily property with cardio equipment, free weights, and functional training space.",
      "link": "false",
      "alt_text": "Bright gym interior with treadmills, weight racks, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/Jackstraw-JoshPartee-6747+%281%29.jpg"
    },
    {
      "id": "ec_9a04615a199fa1381107ddc4",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-1f49-77cf-a3bf-fdf64633100e.webp",
      "image_media": {
        "alt_text": "Indoor gym with stationary bikes and cardio equipment.",
        "public_id": "019cfde3-1f49-77cf-a3bf-fdf64633100e",
        "storage_key": "property/6767906449166986/019cfde3-1f49-77cf-a3bf-fdf64633100e.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Community",
      "description": "Modern community fitness center featuring stationary bikes and cardio equipment.",
      "link": "false",
      "alt_text": "Indoor gym with stationary bikes and cardio equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/18-web-or-mls-Riley+Visuals-18+%281%29.jpg"
    },
    {
      "id": "ec_0df4e5a202d847383c34f5a2",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-20ec-74ac-8bd4-cf3d07f29bd6.webp",
      "image_media": {
        "alt_text": "Bike storage area with multiple wall-mounted racks on a plywood wall and a bicycle.",
        "public_id": "019cfde3-20ec-74ac-8bd4-cf3d07f29bd6",
        "storage_key": "property/6767906449166986/019cfde3-20ec-74ac-8bd4-cf3d07f29bd6.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Community",
      "description": "Community bike storage area with wall-mounted racks for residents' bicycles.",
      "link": "false",
      "alt_text": "Bike storage area with multiple wall-mounted racks on a plywood wall and a bicycle.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/1-web-or-mls-Riley+Visuals-1+%281%29.jpg"
    },
    {
      "id": "ec_68639e61542730be3cfe6104",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-20f8-7734-adb0-2fc09dbd3e34.webp",
      "image_media": {
        "alt_text": "Shower area with dark gray tile walls and a handheld shower.",
        "public_id": "019cfde3-20f8-7734-adb0-2fc09dbd3e34",
        "storage_key": "property/6767906449166986/019cfde3-20f8-7734-adb0-2fc09dbd3e34.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring dark rectangular tile walls and a handheld shower fixture.",
      "link": "false",
      "alt_text": "Shower area with dark gray tile walls and a handheld shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/6-web-or-mls-Riley+Visuals-6-bb657333.jpg"
    },
    {
      "id": "ec_23abb48827e2f541b5863d99",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-292e-775c-9867-2b5e4bfb008f.webp",
      "image_media": {
        "alt_text": "Tool-filled workbench with pegboard in a maintenance room.",
        "public_id": "019cfde3-292e-775c-9867-2b5e4bfb008f",
        "storage_key": "property/6767906449166986/019cfde3-292e-775c-9867-2b5e4bfb008f.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Other",
      "description": "Maintenance workshop at the property featuring a pegboard, tools, and a workbench for repairs.",
      "link": "false",
      "alt_text": "Tool-filled workbench with pegboard in a maintenance room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/9-web-or-mls-Riley+Visuals-9.jpg"
    },
    {
      "id": "ec_0966e32ca3b9b8024696c286",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-2af2-7488-a57a-0da0c1661cb0.webp",
      "image_media": {
        "alt_text": "Modern apartment lobby with seating, plants, and glass doors.",
        "public_id": "019cfde3-2af2-7488-a57a-0da0c1661cb0",
        "storage_key": "property/6767906449166986/019cfde3-2af2-7488-a57a-0da0c1661cb0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "A stylish resident lobby featuring contemporary furnishings, greenery, and a welcoming lounge area.",
      "link": "false",
      "alt_text": "Modern apartment lobby with seating, plants, and glass doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/Jackstraw_K+%2826+of+75%29.jpg"
    },
    {
      "id": "ec_3423ccc771963bb3c9b9bb73",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-2e7f-72a9-9ddd-3cedbdf4c122.webp",
      "image_media": {
        "alt_text": "Evening view of a modern apartment courtyard with seating and orange umbrellas.",
        "public_id": "019cfde3-2e7f-72a9-9ddd-3cedbdf4c122",
        "storage_key": "property/6767906449166986/019cfde3-2e7f-72a9-9ddd-3cedbdf4c122.webp",
        "width": 1920,
        "height": 1438
      },
      "title": "Community",
      "description": "Outdoor courtyard in a contemporary multifamily community featuring tables, chairs, umbrellas, and landscaped paths.",
      "link": "false",
      "alt_text": "Evening view of a modern apartment courtyard with seating and orange umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/Jackstraw-JoshPartee-0579.jpg"
    },
    {
      "id": "ec_01e7e8ae9d9df98723d93054",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-30d0-7339-b6a0-24ae66e42155.webp",
      "image_media": {
        "alt_text": "Modern resident lounge with large windows, seating, and a kitchenette.",
        "public_id": "019cfde3-30d0-7339-b6a0-24ae66e42155",
        "storage_key": "property/6767906449166986/019cfde3-30d0-7339-b6a0-24ae66e42155.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "Bright, contemporary common area with a kitchenette, seating, and expansive window views for residents.",
      "link": "false",
      "alt_text": "Modern resident lounge with large windows, seating, and a kitchenette.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/33-web-or-mls-Riley+Visuals-33.jpg"
    },
    {
      "id": "ec_d74ea0efe94ce86294c5a357",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-365c-72bd-9606-45bef44ffbdd.webp",
      "image_media": {
        "alt_text": "Interior hallway with white mailboxes along a wood-trimmed wall; a person walks.",
        "public_id": "019cfde3-365c-72bd-9606-45bef44ffbdd",
        "storage_key": "property/6767906449166986/019cfde3-365c-72bd-9606-45bef44ffbdd.webp",
        "width": 1920,
        "height": 2082
      },
      "title": "Community",
      "description": "Bright modern residential hallway with a long row of mailboxes and a resident walking by.",
      "link": "false",
      "alt_text": "Interior hallway with white mailboxes along a wood-trimmed wall; a person walks.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/Jackstraw-JoshPartee-7284.jpg"
    },
    {
      "id": "ec_980c88c7805bbffc6ff8588f",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-385e-712e-b782-f79132bcb078.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex with multiple buildings, parking lots, and distant mountains.",
        "public_id": "019cfde3-385e-712e-b782-f79132bcb078",
        "storage_key": "property/6767906449166986/019cfde3-385e-712e-b782-f79132bcb078.webp",
        "width": 1920,
        "height": 969
      },
      "title": "Community",
      "description": "Aerial view of a contemporary multifamily community with modern buildings, parking, and tree-lined streets against a mountain backdrop.",
      "link": "false",
      "alt_text": "Aerial view of a modern apartment complex with multiple buildings, parking lots, and distant mountains.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/Jackstraw-JoshPartee-0507.jpg"
    },
    {
      "id": "ec_749f0a5ffe170ba3462a6ccf",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-3e16-70c1-a27e-709cf5d47d71.webp",
      "image_media": {
        "alt_text": "Open-concept kitchen and living area in a modern apartment with light cabinets and stainless steel appliances.",
        "public_id": "019cfde3-3e16-70c1-a27e-709cf5d47d71",
        "storage_key": "property/6767906449166986/019cfde3-3e16-70c1-a27e-709cf5d47d71.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "Bright open-concept apartment featuring a modern kitchen with light cabinetry, stainless appliances, and a cozy living area.",
      "link": "false",
      "alt_text": "Open-concept kitchen and living area in a modern apartment with light cabinets and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/46-web-or-mls-Riley+Visuals-46.jpg"
    },
    {
      "id": "ec_99195e5f5edbd8c6121d4e75",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-3ef9-715d-9ce1-9694c6a32326.webp",
      "image_media": {
        "alt_text": "Open-concept kitchen in a modern apartment with light wood cabinets, stainless steel fridge, and wooden dining table.",
        "public_id": "019cfde3-3ef9-715d-9ce1-9694c6a32326",
        "storage_key": "property/6767906449166986/019cfde3-3ef9-715d-9ce1-9694c6a32326.webp",
        "width": 1920,
        "height": 1284
      },
      "title": "Apartment",
      "description": "Bright, contemporary apartment kitchen featuring white cabinets, a subway tile backsplash, stainless appliances, and a wooden dining table.",
      "link": "false",
      "alt_text": "Open-concept kitchen in a modern apartment with light wood cabinets, stainless steel fridge, and wooden dining table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/47-web-or-mls-Riley+Visuals-47+%281%29.jpg"
    },
    {
      "id": "ec_64627d8722b2ec63899fdeec",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-4407-744d-9d7e-171f2f8a4c87.webp",
      "image_media": {
        "alt_text": "Bright living room with blue sofa, wooden coffee table, and a large window.",
        "public_id": "019cfde3-4407-744d-9d7e-171f2f8a4c87",
        "storage_key": "property/6767906449166986/019cfde3-4407-744d-9d7e-171f2f8a4c87.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "Modern apartment living area with colorful decor, a low wooden coffee table, and a large window overlooking the building outside.",
      "link": "false",
      "alt_text": "Bright living room with blue sofa, wooden coffee table, and a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/52-web-or-mls-Riley+Visuals-52.jpg"
    },
    {
      "id": "ec_4d68514af985213da9e0b94d",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-45b5-7034-81d1-7a885e4cb62c.webp",
      "image_media": {
        "alt_text": "Bedroom in a modern apartment with a wooden bed, green desk, and a large window.",
        "public_id": "019cfde3-45b5-7034-81d1-7a885e4cb62c",
        "storage_key": "property/6767906449166986/019cfde3-45b5-7034-81d1-7a885e4cb62c.webp",
        "width": 1920,
        "height": 1284
      },
      "title": "Apartment",
      "description": "Bright bedroom in a modern apartment featuring a wooden headboard, patterned bedding, a green desk, and a large window with urban views.",
      "link": "false",
      "alt_text": "Bedroom in a modern apartment with a wooden bed, green desk, and a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/55-web-or-mls-Riley+Visuals-55.jpg"
    },
    {
      "id": "ec_fcb2dd2589fdf79e1dd81cf2",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-4bc5-735b-802e-286ceabc007b.webp",
      "image_media": {
        "alt_text": "Bedroom with bed, large green art, open closet, and doorway to kitchen.",
        "public_id": "019cfde3-4bc5-735b-802e-286ceabc007b",
        "storage_key": "property/6767906449166986/019cfde3-4bc5-735b-802e-286ceabc007b.webp",
        "width": 1920,
        "height": 1285
      },
      "title": "Apartment",
      "description": "Bright apartment bedroom with a large green art piece, open closet, and doorway to the kitchen/dining area.",
      "link": "false",
      "alt_text": "Bedroom with bed, large green art, open closet, and doorway to kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/56-web-or-mls-Riley+Visuals-56.jpg"
    },
    {
      "id": "ec_d8138771a5fe4767fcfffd6a",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-cef0-72cf-8edb-5bb004c6fa12.webp",
      "image_media": {
        "alt_text": "Walk-in closet with white walls, hanging rods, shelves, and clothing on hangers",
        "public_id": "019cfde3-cef0-72cf-8edb-5bb004c6fa12",
        "storage_key": "property/6767906449166986/019cfde3-cef0-72cf-8edb-5bb004c6fa12.webp",
        "width": 1920,
        "height": 1284
      },
      "title": "Apartment",
      "description": "A neatly organized walk-in closet in a modern apartment, featuring rod storage, shelves, and hanging space.",
      "link": "false",
      "alt_text": "Walk-in closet with white walls, hanging rods, shelves, and clothing on hangers",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/57-web-or-mls-Riley+Visuals-57.jpg"
    },
    {
      "id": "ec_c238c97996f65b22767b2bbf",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-4e60-76cf-81c2-374f391dcd94.webp",
      "image_media": {
        "alt_text": "Stacked washer and dryer in a laundry alcove beside a closet and hallway.",
        "public_id": "019cfde3-4e60-76cf-81c2-374f391dcd94",
        "storage_key": "property/6767906449166986/019cfde3-4e60-76cf-81c2-374f391dcd94.webp",
        "width": 1920,
        "height": 1285
      },
      "title": "Apartment",
      "description": "Bright in-unit laundry area with stacked washer/dryer and a nearby coat closet, opening to the hallway and living space.",
      "link": "false",
      "alt_text": "Stacked washer and dryer in a laundry alcove beside a closet and hallway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/59-web-or-mls-Riley+Visuals-59.jpg"
    },
    {
      "id": "ec_96d800b7d501824e2a813059",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-5144-748a-b227-449d9f2f2b74.webp",
      "image_media": {
        "alt_text": "Bright bathroom with a long white vanity, sink, toilet, and a tub/shower combo.",
        "public_id": "019cfde3-5144-748a-b227-449d9f2f2b74",
        "storage_key": "property/6767906449166986/019cfde3-5144-748a-b227-449d9f2f2b74.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with a light-wood vanity, white countertop, toilet, and a tub/shower.",
      "link": "false",
      "alt_text": "Bright bathroom with a long white vanity, sink, toilet, and a tub/shower combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/60-web-or-mls-Riley+Visuals-60.jpg"
    },
    {
      "id": "ec_e51610a7dc5f2cb1a0b47e30",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-5100-72be-a977-3e9481d17dc9.webp",
      "image_media": {
        "alt_text": "Bright modern kitchen with white cabinets, stainless steel fridge and stove, and a large island.",
        "public_id": "019cfde3-5100-72be-a977-3e9481d17dc9",
        "storage_key": "property/6767906449166986/019cfde3-5100-72be-a977-3e9481d17dc9.webp",
        "width": 1920,
        "height": 1284
      },
      "title": "Apartment",
      "description": "Open-concept kitchen in a modern apartment with a large island, quartz countertops, and stainless steel appliances.",
      "link": "false",
      "alt_text": "Bright modern kitchen with white cabinets, stainless steel fridge and stove, and a large island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/8-web-or-mls-Riley+Visuals-8.jpg"
    },
    {
      "id": "ec_6b3d89ebf387759c47fba60a",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-57ed-7746-ae35-71a2257d6bdb.webp",
      "image_media": {
        "alt_text": "Open-concept kitchen with island and sink; living area visible, plus a laundry closet with stacked washer/dryer.",
        "public_id": "019cfde3-57ed-7746-ae35-71a2257d6bdb",
        "storage_key": "property/6767906449166986/019cfde3-57ed-7746-ae35-71a2257d6bdb.webp",
        "width": 1920,
        "height": 1284
      },
      "title": "Apartment",
      "description": "Spacious modern apartment featuring an open kitchen, island seating, bright living space, and a stacked washer/dryer in the laundry closet.",
      "link": "false",
      "alt_text": "Open-concept kitchen with island and sink; living area visible, plus a laundry closet with stacked washer/dryer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/7-web-or-mls-Riley+Visuals-7.jpg"
    },
    {
      "id": "ec_cdd02cc58d5a28660cebde8f",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-5ad2-749c-ab79-0a29248a5ac6.webp",
      "image_media": {
        "alt_text": "Open-concept living space with a white kitchen island, dining table, and seating by large windows.",
        "public_id": "019cfde3-5ad2-749c-ab79-0a29248a5ac6",
        "storage_key": "property/6767906449166986/019cfde3-5ad2-749c-ab79-0a29248a5ac6.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "Bright, modern apartment interior featuring a white island kitchen, dining area, and a cozy living space.",
      "link": "false",
      "alt_text": "Open-concept living space with a white kitchen island, dining table, and seating by large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/19-web-or-mls-Riley+Visuals-19.jpg"
    },
    {
      "id": "ec_6f05f0262db9b9d4627e96b0",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-5bc8-762f-96b3-5e7b4a2fbd3d.webp",
      "image_media": {
        "alt_text": "Living room in a modern apartment with a dark sofa, coffee table, and open kitchen.",
        "public_id": "019cfde3-5bc8-762f-96b3-5e7b4a2fbd3d",
        "storage_key": "property/6767906449166986/019cfde3-5bc8-762f-96b3-5e7b4a2fbd3d.webp",
        "width": 1920,
        "height": 1284
      },
      "title": "Apartment",
      "description": "Bright, contemporary living area with a plush sofa, abstract wall art, and an open-plan kitchen and dining space.",
      "link": "false",
      "alt_text": "Living room in a modern apartment with a dark sofa, coffee table, and open kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/3-web-or-mls-Riley+Visuals-3.jpg"
    },
    {
      "id": "ec_f7e78ee1e1d5492578b40a43",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-602f-7469-a9fa-8df97f3e9e2e.webp",
      "image_media": {
        "alt_text": "Bedroom in a modern apartment with a bed, nightstands, a large mirror, and a window view.",
        "public_id": "019cfde3-602f-7469-a9fa-8df97f3e9e2e",
        "storage_key": "property/6767906449166986/019cfde3-602f-7469-a9fa-8df97f3e9e2e.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "Cozy bedroom in a contemporary apartment with plush bedding, warm lighting, and a large window.",
      "link": "false",
      "alt_text": "Bedroom in a modern apartment with a bed, nightstands, a large mirror, and a window view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/11-web-or-mls-Riley+Visuals-11+%281%29.jpg"
    },
    {
      "id": "ec_8f5edcebac165ed1bdd2335a",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-6652-701b-a34d-84fd8128bd72.webp",
      "image_media": {
        "alt_text": "Bedroom with white walls, bed in foreground, and doors to bathroom and walk-in closet.",
        "public_id": "019cfde3-6652-701b-a34d-84fd8128bd72",
        "storage_key": "property/6767906449166986/019cfde3-6652-701b-a34d-84fd8128bd72.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "Bright bedroom in a modern apartment with an adjacent bathroom and walk-in closet; built-in shelves and warm lighting.",
      "link": "false",
      "alt_text": "Bedroom with white walls, bed in foreground, and doors to bathroom and walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/12-web-or-mls-Riley+Visuals-12.jpg"
    },
    {
      "id": "ec_3741a5eeaa5b577d6c1fca15",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-6686-7189-a208-ac88dc6fb852.webp",
      "image_media": {
        "alt_text": "Bedroom in a modern apartment with a large window, bed, and wooden desk.",
        "public_id": "019cfde3-6686-7189-a208-ac88dc6fb852",
        "storage_key": "property/6767906449166986/019cfde3-6686-7189-a208-ac88dc6fb852.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "Contemporary furnished bedroom in a stylish apartment with natural light and a wooden desk.",
      "link": "false",
      "alt_text": "Bedroom in a modern apartment with a large window, bed, and wooden desk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/22-web-or-mls-Riley+Visuals-22.jpg"
    },
    {
      "id": "ec_e59af470c16f6888134282f6",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-7029-71cc-9a93-d027236970da.webp",
      "image_media": {
        "alt_text": "Bedroom with a dark dresser, large abstract painting, and an open closet.",
        "public_id": "019cfde3-7029-71cc-9a93-d027236970da",
        "storage_key": "property/6767906449166986/019cfde3-7029-71cc-9a93-d027236970da.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Modern apartment bedroom with a dark dresser, bold abstract art, and an open closet.",
      "link": "false",
      "alt_text": "Bedroom with a dark dresser, large abstract painting, and an open closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/34-web-or-mls-Riley+Visuals-34.jpg"
    },
    {
      "id": "ec_ba7837db0eb75c65af7f5784",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-7090-71e9-bfd8-d51c6d867002.webp",
      "image_media": {
        "alt_text": "Bright living area with large window and glass door, featuring a tall wooden bookshelf.",
        "public_id": "019cfde3-7090-71e9-bfd8-d51c6d867002",
        "storage_key": "property/6767906449166986/019cfde3-7090-71e9-bfd8-d51c6d867002.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "A stylish apartment living area bathed in natural light, featuring a tall wooden bookshelf and light wood floors.",
      "link": "false",
      "alt_text": "Bright living area with large window and glass door, featuring a tall wooden bookshelf.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/36-web-or-mls-Riley+Visuals-36.jpg"
    },
    {
      "id": "ec_9ecae90a43872477c9075284",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-7301-71f2-a382-48169049c3ae.webp",
      "image_media": {
        "alt_text": "Bathroom with a double vanity, toilet, large mirror, and an open closet with shelves.",
        "public_id": "019cfde3-7301-71f2-a382-48169049c3ae",
        "storage_key": "property/6767906449166986/019cfde3-7301-71f2-a382-48169049c3ae.webp",
        "width": 1920,
        "height": 1284
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom featuring a double vanity, sleek fixtures, and an open walk-in closet.",
      "link": "false",
      "alt_text": "Bathroom with a double vanity, toilet, large mirror, and an open closet with shelves.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/13-web-or-mls-Riley+Visuals-13.jpg"
    },
    {
      "id": "ec_a71028299c68e957662bf44b",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-7b84-738c-a718-39bd994f6dbe.webp",
      "image_media": {
        "alt_text": "Bathroom with a single-sink vanity, large mirror, toilet, and a shower with a curtain.",
        "public_id": "019cfde3-7b84-738c-a718-39bd994f6dbe",
        "storage_key": "property/6767906449166986/019cfde3-7b84-738c-a718-39bd994f6dbe.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with a light wood vanity, white countertop, framed art, and neutral decor.",
      "link": "false",
      "alt_text": "Bathroom with a single-sink vanity, large mirror, toilet, and a shower with a curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/20-web-or-mls-Riley+Visuals-20.jpg"
    },
    {
      "id": "ec_e2ce9ad6d402a2cbe4a663d5",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-7e07-71e4-8d1e-748d38bae264.webp",
      "image_media": {
        "alt_text": "Modern kitchen with wood-tone cabinets, stainless steel refrigerator, range, and sink.",
        "public_id": "019cfde3-7e07-71e4-8d1e-748d38bae264",
        "storage_key": "property/6767906449166986/019cfde3-7e07-71e4-8d1e-748d38bae264.webp",
        "width": 1920,
        "height": 1284
      },
      "title": "Apartment",
      "description": "Spacious kitchen in a modern apartment featuring wood-tone cabinetry, stainless steel appliances, and a glossy white tile backsplash.",
      "link": "false",
      "alt_text": "Modern kitchen with wood-tone cabinets, stainless steel refrigerator, range, and sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/28-web-or-mls-Riley+Visuals-28+%281%29.jpg"
    },
    {
      "id": "ec_c1e6655c86a89001fe579e2d",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-7e4e-74de-af1a-32cbecf12f10.webp",
      "image_media": {
        "alt_text": "Open-plan kitchen with wood cabinets, stainless steel appliances, and light wood floors.",
        "public_id": "019cfde3-7e4e-74de-af1a-32cbecf12f10",
        "storage_key": "property/6767906449166986/019cfde3-7e4e-74de-af1a-32cbecf12f10.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Bright, modern apartment featuring an open kitchen, stainless appliances, and light wood floors.",
      "link": "false",
      "alt_text": "Open-plan kitchen with wood cabinets, stainless steel appliances, and light wood floors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/26-web-or-mls-Riley+Visuals-26.jpg"
    },
    {
      "id": "ec_e9bfeb1123f8c428c55eb26b",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-8256-77ad-ad86-2f4242950139.webp",
      "image_media": {
        "alt_text": "Bright empty room with large window and light wood floors.",
        "public_id": "019cfde3-8256-77ad-ad86-2f4242950139",
        "storage_key": "property/6767906449166986/019cfde3-8256-77ad-ad86-2f4242950139.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "Bright, modern apartment room with a large window and light wood flooring.",
      "link": "false",
      "alt_text": "Bright empty room with large window and light wood floors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/23-web-or-mls-Riley+Visuals-23.jpg"
    },
    {
      "id": "ec_466b48d6e1568dc5f6c91549",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-87c8-711c-b81d-86072dfddac8.webp",
      "image_media": {
        "alt_text": "Open closet with shelves and hanging rod next to a modern kitchen.",
        "public_id": "019cfde3-87c8-711c-b81d-86072dfddac8",
        "storage_key": "property/6767906449166986/019cfde3-87c8-711c-b81d-86072dfddac8.webp",
        "width": 1920,
        "height": 1285
      },
      "title": "Apartment",
      "description": "Interior of a contemporary apartment showing a built-in closet system and a modern kitchen with stainless appliances.",
      "link": "false",
      "alt_text": "Open closet with shelves and hanging rod next to a modern kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/29-web-or-mls-Riley+Visuals-31+%282%29.jpg"
    },
    {
      "id": "ec_73571546c944b04f6b8be1c4",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-8ac5-75de-86a5-7d107256a507.webp",
      "image_media": {
        "alt_text": "Apartment bathroom with a wood vanity, white countertop, large mirror, and a tub/shower.",
        "public_id": "019cfde3-8ac5-75de-86a5-7d107256a507",
        "storage_key": "property/6767906449166986/019cfde3-8ac5-75de-86a5-7d107256a507.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with a wood vanity, white countertop, and a tub/shower combo.",
      "link": "false",
      "alt_text": "Apartment bathroom with a wood vanity, white countertop, large mirror, and a tub/shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/32-web-or-mls-Riley+Visuals-32.jpg"
    },
    {
      "id": "ec_464160ce36020e296c90071a",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-8b34-721b-9ab6-9f2bfc5b8b6e.webp",
      "image_media": {
        "alt_text": "Bright open-concept kitchen with stainless steel appliances, an island, and a marble dining table.",
        "public_id": "019cfde3-8b34-721b-9ab6-9f2bfc5b8b6e",
        "storage_key": "property/6767906449166986/019cfde3-8b34-721b-9ab6-9f2bfc5b8b6e.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "Bright, modern apartment kitchen with stainless steel appliances, a spacious island, and a marble dining table.",
      "link": "false",
      "alt_text": "Bright open-concept kitchen with stainless steel appliances, an island, and a marble dining table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/Miranda-Jackstraw-Living+Dining+2-staged-MJ.jpg"
    },
    {
      "id": "ec_0b6d64b80b46878b9eea1146",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-8eaa-712b-bdc4-691c3846a3fc.webp",
      "image_media": {
        "alt_text": "Loft-style community fitness area with a stationary bike, weights, and a desk near large windows.",
        "public_id": "019cfde3-8eaa-712b-bdc4-691c3846a3fc",
        "storage_key": "property/6767906449166986/019cfde3-8eaa-712b-bdc4-691c3846a3fc.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Bright resident amenity space featuring a home gym with a stationary bike, weights, and a work desk beside a railing with expansive windows.",
      "link": "false",
      "alt_text": "Loft-style community fitness area with a stationary bike, weights, and a desk near large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/Miranda-Jackstraw-Office-staged-corrected-MM.jpg"
    },
    {
      "id": "ec_d5a6dba5b3c90f61ce97e53e",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-9204-7079-bc9a-11d6983dbba6.webp",
      "image_media": {
        "alt_text": "Bright living room with tall ceilings, large windows, white walls, and a beige sectional sofa.",
        "public_id": "019cfde3-9204-7079-bc9a-11d6983dbba6",
        "storage_key": "property/6767906449166986/019cfde3-9204-7079-bc9a-11d6983dbba6.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "Open-concept living area in a modern apartment with expansive windows, light wood floors, and a beige sectional.",
      "link": "false",
      "alt_text": "Bright living room with tall ceilings, large windows, white walls, and a beige sectional sofa.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/Miranda-Jackstraw-Living+Dining_staged_corrected_v1_KTA.jpg"
    },
    {
      "id": "ec_94b1db6e8e66e7332f66c179",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-973b-748b-bc5c-5f6af8beeb5a.webp",
      "image_media": {
        "alt_text": "Two-story living room with large windows, white walls, and a brown sectional sofa.",
        "public_id": "019cfde3-973b-748b-bc5c-5f6af8beeb5a",
        "storage_key": "property/6767906449166986/019cfde3-973b-748b-bc5c-5f6af8beeb5a.webp",
        "width": 1920,
        "height": 1285
      },
      "title": "Apartment",
      "description": "Bright, modern living room in a multi-story apartment with expansive windows, natural light, and a cozy seating area.",
      "link": "false",
      "alt_text": "Two-story living room with large windows, white walls, and a brown sectional sofa.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/Miranda-Jackstraw-Living+Dining+3+staged+corrected+v1+AK.jpg"
    },
    {
      "id": "ec_550b86a44a0dc6b1b67676ef",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-9726-7369-a448-5444c9a7bd04.webp",
      "image_media": {
        "alt_text": "Open living area with light wood floors, white walls, a staircase to a loft, and a modern kitchen.",
        "public_id": "019cfde3-9726-7369-a448-5444c9a7bd04",
        "storage_key": "property/6767906449166986/019cfde3-9726-7369-a448-5444c9a7bd04.webp",
        "width": 1920,
        "height": 1284
      },
      "title": "Apartment",
      "description": "Spacious open-concept apartment with a staircase to a mezzanine and a modern kitchen.",
      "link": "false",
      "alt_text": "Open living area with light wood floors, white walls, a staircase to a loft, and a modern kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/64-web-or-mls-Riley+Visuals-64.jpg"
    },
    {
      "id": "ec_4adae1579187b3a4e44c7c10",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-9c74-748b-aad0-5a3f01a8d48a.webp",
      "image_media": {
        "alt_text": "Open-concept kitchen with island, light cabinets, stainless steel appliances, and stairs.",
        "public_id": "019cfde3-9c74-748b-aad0-5a3f01a8d48a",
        "storage_key": "property/6767906449166986/019cfde3-9c74-748b-aad0-5a3f01a8d48a.webp",
        "width": 1920,
        "height": 1285
      },
      "title": "Apartment",
      "description": "Bright, modern apartment kitchen with island, light wood cabinetry, and stainless-steel appliances.",
      "link": "false",
      "alt_text": "Open-concept kitchen with island, light cabinets, stainless steel appliances, and stairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/67-web-or-mls-Riley+Visuals-67+%281%29.jpg"
    },
    {
      "id": "ec_c037cce1b53b63445868d188",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-9d6d-7350-9bfb-35bccfc9db38.webp",
      "image_media": {
        "alt_text": "Open-concept living area with kitchen island, staircase, and large windows.",
        "public_id": "019cfde3-9d6d-7350-9bfb-35bccfc9db38",
        "storage_key": "property/6767906449166986/019cfde3-9d6d-7350-9bfb-35bccfc9db38.webp",
        "width": 1920,
        "height": 1284
      },
      "title": "Apartment",
      "description": "Bright, modern apartment interior with a spacious kitchen island, stainless steel appliances, and light hardwood floors.",
      "link": "false",
      "alt_text": "Open-concept living area with kitchen island, staircase, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/65-web-or-mls-Riley+Visuals-65.jpg"
    },
    {
      "id": "ec_7fc8bd1f3dca3b089a869eb4",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-a396-7364-9909-2c118271b7ec.webp",
      "image_media": {
        "alt_text": "Upper-floor loft-style apartment interior with white railing, large windows and light wood flooring.",
        "public_id": "019cfde3-a396-7364-9909-2c118271b7ec",
        "storage_key": "property/6767906449166986/019cfde3-a396-7364-9909-2c118271b7ec.webp",
        "width": 1920,
        "height": 1284
      },
      "title": "Apartment",
      "description": "Bright, modern loft-style apartment interior with open space, white walls, and abundant natural light.",
      "link": "false",
      "alt_text": "Upper-floor loft-style apartment interior with white railing, large windows and light wood flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/83-web-or-mls-Riley+Visuals-84.jpg"
    },
    {
      "id": "ec_3f5edca2ccffe7ed335f4f3a",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-a3da-7388-8168-f568c764a2ea.webp",
      "image_media": {
        "alt_text": "Open white walk-in closet with shelves and rod, opening to a bright room with a window.",
        "public_id": "019cfde3-a3da-7388-8168-f568c764a2ea",
        "storage_key": "property/6767906449166986/019cfde3-a3da-7388-8168-f568c764a2ea.webp",
        "width": 1920,
        "height": 1285
      },
      "title": "Apartment",
      "description": "Bright, empty apartment interior showing a walk-in closet with shelves, leading into a sunlit room with a window.",
      "link": "false",
      "alt_text": "Open white walk-in closet with shelves and rod, opening to a bright room with a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/78-web-or-mls-Riley+Visuals-79.jpg"
    },
    {
      "id": "ec_0f04262fd351ce98fa4ef996",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-a82f-74a0-8378-3e42d26ac79c.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with double sinks, large mirror, and a toilet.",
        "public_id": "019cfde3-a82f-74a0-8378-3e42d26ac79c",
        "storage_key": "property/6767906449166986/019cfde3-a82f-74a0-8378-3e42d26ac79c.webp",
        "width": 1920,
        "height": 1285
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom featuring a double-sink vanity, sleek fixtures, and a nearby toilet.",
      "link": "false",
      "alt_text": "Bathroom vanity with double sinks, large mirror, and a toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/87-web-or-mls-Riley+Visuals-88.jpg"
    },
    {
      "id": "ec_8158439a4f346fb7afdcc0f6",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-a96d-770a-b340-afe3f86547fc.webp",
      "image_media": {
        "alt_text": "Exterior entrance of a modern apartment building with glass doors and landscaped walkway.",
        "public_id": "019cfde3-a96d-770a-b340-afe3f86547fc",
        "storage_key": "property/6767906449166986/019cfde3-a96d-770a-b340-afe3f86547fc.webp",
        "width": 1920,
        "height": 1284
      },
      "title": "Community",
      "description": "Exterior shot of a contemporary apartment building with large windows, entry doors, and a landscaped entry pathway.",
      "link": "false",
      "alt_text": "Exterior entrance of a modern apartment building with glass doors and landscaped walkway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/94-web-or-mls-Riley+Visuals-95.jpg"
    },
    {
      "id": "ec_1fce3ea58c8c13a172df6e91",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-aed8-77db-a5eb-97be252deb66.webp",
      "image_media": {
        "alt_text": "Small black logo on white background.",
        "public_id": "019cfde3-aed8-77db-a5eb-97be252deb66",
        "storage_key": "property/6767906449166986/019cfde3-aed8-77db-a5eb-97be252deb66.webp",
        "width": 86,
        "height": 42
      },
      "title": "Logo",
      "description": "Brand logo graphic for the property on a plain white background.",
      "link": "false",
      "alt_text": "Small black logo on white background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7f198d9d/dms3rep/multi/Repli_White_Logo-1-efa63f62-640w.png"
    },
    {
      "id": "ec_f0d42c0beea8063183f7dbeb",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-af4f-749b-a0d7-ec20ab95bcea.webp",
      "image_media": {
        "alt_text": "Circular loading spinner icon made of white dots.",
        "public_id": "019cfde3-af4f-749b-a0d7-ec20ab95bcea",
        "storage_key": "property/6767906449166986/019cfde3-af4f-749b-a0d7-ec20ab95bcea.webp",
        "width": 40,
        "height": 40
      },
      "title": "Other",
      "description": "Icon of a circular loading spinner, used as a placeholder in the gallery.",
      "link": "false",
      "alt_text": "Circular loading spinner icon made of white dots.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.userway.org/widgetapp/images/spin_wh.svg"
    },
    {
      "id": "ec_297f3e450a2d7493cdec4a86",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-b29a-7068-a738-4f8fa6740737.webp",
      "image_media": {
        "alt_text": "White universal accessibility icon inside a black circular background.",
        "public_id": "019cfde3-b29a-7068-a738-4f8fa6740737",
        "storage_key": "property/6767906449166986/019cfde3-b29a-7068-a738-4f8fa6740737.webp",
        "width": 60,
        "height": 60
      },
      "title": "Other",
      "description": "Icon representing accessibility features for the property gallery.",
      "link": "false",
      "alt_text": "White universal accessibility icon inside a black circular background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.userway.org/widgetapp/images/body_wh.svg"
    },
    {
      "id": "ec_f7622d964c7b3b79eb0603aa",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-b6df-777e-b6b2-c6aa23a41e8b.webp",
      "image_media": {
        "alt_text": "Interior view of a modern apartment lobby with a curved sectional and sculptural ceiling.",
        "public_id": "019cfde3-b6df-777e-b6b2-c6aa23a41e8b",
        "storage_key": "property/6767906449166986/019cfde3-b6df-777e-b6b2-c6aa23a41e8b.webp",
        "width": 1920,
        "height": 1731
      },
      "title": "Community",
      "description": "Stylish resident lobby with contemporary seating, artwork, and warm lighting.",
      "link": "false",
      "alt_text": "Interior view of a modern apartment lobby with a curved sectional and sculptural ceiling.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/7f198d9d/dms3rep/multi/opt/Jackstraw-JoshPartee-6630-1920w.jpg"
    },
    {
      "id": "ec_0fa546cd5ae86b1a85f0aae8",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-b871-73df-8111-8bea4b444a75.webp",
      "image_media": {
        "alt_text": "Modern community lounge with a long table, black pendant lights, and seating; people visible in the background.",
        "public_id": "019cfde3-b871-73df-8111-8bea4b444a75",
        "storage_key": "property/6767906449166986/019cfde3-b871-73df-8111-8bea4b444a75.webp",
        "width": 1920,
        "height": 1635
      },
      "title": "Community",
      "description": "A modern multifamily community lounge with a long central table, warm seating, pendant lights, and a kitchenette along the wall.",
      "link": "false",
      "alt_text": "Modern community lounge with a long table, black pendant lights, and seating; people visible in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/7f198d9d/dms3rep/multi/opt/Jackstraw-JoshPartee-6514-1920w.jpg"
    },
    {
      "id": "ec_7b3b59f3bf7bc3791b9ba825",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-1f49-77cf-a3bf-fdf64633100e.webp",
      "image_media": {
        "alt_text": "Indoor community gym featuring two stationary bikes with screens.",
        "public_id": "019cfde3-1f49-77cf-a3bf-fdf64633100e",
        "storage_key": "property/6767906449166986/019cfde3-1f49-77cf-a3bf-fdf64633100e.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Community",
      "description": "Modern community gym at the property with Peloton-style spinning bikes and mounted screens.",
      "link": "false",
      "alt_text": "Indoor community gym featuring two stationary bikes with screens.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/7f198d9d/dms3rep/multi/opt/18-web-or-mls-Riley+Visuals-18-1920w.jpg"
    },
    {
      "id": "ec_e9b41c319846233ab2bddfca",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-bbe9-70b0-a3eb-f02c03dd2aaf.webp",
      "image_media": {
        "alt_text": "Interior community lounge with wood-paneled walls, framed art, and a long table with green chairs.",
        "public_id": "019cfde3-bbe9-70b0-a3eb-f02c03dd2aaf",
        "storage_key": "property/6767906449166986/019cfde3-bbe9-70b0-a3eb-f02c03dd2aaf.webp",
        "width": 1920,
        "height": 1944
      },
      "title": "Community",
      "description": "Stylish resident lounge featuring warm wood walls, art gallery, and a communal table for gatherings.",
      "link": "false",
      "alt_text": "Interior community lounge with wood-paneled walls, framed art, and a long table with green chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/7f198d9d/dms3rep/multi/opt/Jackstraw-JoshPartee-6657-1920w.jpg"
    },
    {
      "id": "ec_f515c35ac3bac88c23c0678b",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-bf6c-73f2-8460-301c50c5fb3e.webp",
      "image_media": {
        "alt_text": "Modern apartment community lounge featuring a long table, seating, pendant lights, wood accent wall, and large windows.",
        "public_id": "019cfde3-bf6c-73f2-8460-301c50c5fb3e",
        "storage_key": "property/6767906449166986/019cfde3-bf6c-73f2-8460-301c50c5fb3e.webp",
        "width": 1920,
        "height": 1978
      },
      "title": "Community",
      "description": "Bright community lounge with a long dining table, warm wood wall, and expansive windows; ideal for socializing and coworking.",
      "link": "false",
      "alt_text": "Modern apartment community lounge featuring a long table, seating, pendant lights, wood accent wall, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/7f198d9d/dms3rep/multi/opt/Jackstraw-JoshPartee-7185-1920w.jpg"
    },
    {
      "id": "ec_782eabfc76c8af3bbac16c5a",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c4c4-755e-a1b5-4b15f321bd82.webp",
      "image_media": {
        "alt_text": "Modern apartment community lounge with blue couches, wooden tables, wall art, and large windows.",
        "public_id": "019cfde3-c4c4-755e-a1b5-4b15f321bd82",
        "storage_key": "property/6767906449166986/019cfde3-c4c4-755e-a1b5-4b15f321bd82.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "A comfortable resident lounge with blue sectional seating, round wood tables, and contemporary wall art, perfect for socializing and relaxing.",
      "link": "false",
      "alt_text": "Modern apartment community lounge with blue couches, wooden tables, wall art, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/7f198d9d/dms3rep/multi/opt/Jackstraw_K+%2840+of+75%29-1920w.jpg"
    },
    {
      "id": "ec_f9d45eeccf72c788eeb75a6e",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-3e16-70c1-a27e-709cf5d47d71.webp",
      "image_media": {
        "alt_text": "Open-concept apartment kitchen and living area with light cabinets and stainless-steel appliances.",
        "public_id": "019cfde3-3e16-70c1-a27e-709cf5d47d71",
        "storage_key": "property/6767906449166986/019cfde3-3e16-70c1-a27e-709cf5d47d71.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "Bright, modern apartment with an open-concept kitchen, stainless-steel appliances, and a cozy living and dining area.",
      "link": "false",
      "alt_text": "Open-concept apartment kitchen and living area with light cabinets and stainless-steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/7f198d9d/dms3rep/multi/opt/46-web-or-mls-Riley+Visuals-46-1920w.jpg"
    },
    {
      "id": "ec_59398576438a965db4d87e5d",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c752-76fe-8737-d47217e2ffa4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with wood cabinets, stainless fridge, island, and large window view.",
        "public_id": "019cfde3-c752-76fe-8737-d47217e2ffa4",
        "storage_key": "property/6767906449166986/019cfde3-c752-76fe-8737-d47217e2ffa4.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "Bright, contemporary apartment kitchen with an island, wood-toned cabinets, stainless appliances, and a large window overlooking outdoor scenery.",
      "link": "false",
      "alt_text": "Modern kitchen with wood cabinets, stainless fridge, island, and large window view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/7f198d9d/dms3rep/multi/opt/41-web-or-mls-RileyVisuals-unit+635-1920w.JPG"
    },
    {
      "id": "ec_5135c116c414434c07b5a785",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "image_media": {
        "alt_text": "Balcony view of a town with trees and distant mountains under a blue sky.",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Community",
      "description": "Apartment view from a balcony showing a town and distant mountains.",
      "link": "false",
      "alt_text": "Balcony view of a town with trees and distant mountains under a blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/7f198d9d/dms3rep/multi/opt/26-web-or-mls-RileyVisuals-unit+645-1920w.jpg"
    },
    {
      "id": "ec_177d3fbce6ef93c8076de69e",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-cb93-7599-a140-040407895867.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with light wood cabinets and stainless steel appliances.",
        "public_id": "019cfde3-cb93-7599-a140-040407895867",
        "storage_key": "property/6767906449166986/019cfde3-cb93-7599-a140-040407895867.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "Bright, contemporary apartment kitchen with light wood cabinets, stainless steel appliances, and a subway tile backsplash.",
      "link": "false",
      "alt_text": "Modern apartment kitchen with light wood cabinets and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/7f198d9d/dms3rep/multi/opt/48-web-or-mls-Riley+Visuals-48-1920w.jpg"
    },
    {
      "id": "ec_73e2ca93b761b4032f76963b",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-cef0-72cf-8edb-5bb004c6fa12.webp",
      "image_media": {
        "alt_text": "Walk-in closet with white shelving and hanging rods.",
        "public_id": "019cfde3-cef0-72cf-8edb-5bb004c6fa12",
        "storage_key": "property/6767906449166986/019cfde3-cef0-72cf-8edb-5bb004c6fa12.webp",
        "width": 1920,
        "height": 1284
      },
      "title": "Apartment",
      "description": "Bright walk-in closet in a modern apartment with organized shelves and hanging space for clothes.",
      "link": "false",
      "alt_text": "Walk-in closet with white shelving and hanging rods.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/7f198d9d/dms3rep/multi/opt/57-web-or-mls-Riley+Visuals-57+%281%29-1920w.jpg"
    },
    {
      "id": "ec_3481492a682c20a888a50e6b",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-d2ca-76e2-88f3-560fb70bd17e.webp",
      "image_media": {
        "alt_text": "Bedroom with beige bedding, a metal bed frame, pillows, lamp, and tall plants by a window.",
        "public_id": "019cfde3-d2ca-76e2-88f3-560fb70bd17e",
        "storage_key": "property/6767906449166986/019cfde3-d2ca-76e2-88f3-560fb70bd17e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Modern apartment bedroom with neutral tones, wall art, and greenery for a welcoming, cozy feel.",
      "link": "false",
      "alt_text": "Bedroom with beige bedding, a metal bed frame, pillows, lamp, and tall plants by a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/7f198d9d/dms3rep/multi/opt/Jackstraw_K+%2851+of+75%29-1920w.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_8fba906a866329407e3957f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Sisters Coffee Company - Old Mill",
      "poi_type": "Restaurants",
      "poi_address": "450 SW Powerhouse Dr #400, Bend, OR 97702, USA",
      "poi_short_description": "House-roasted coffee drinks & light lunch fare such as pastries & sandwiches in a stylish space.",
      "poi_long_description": "House-roasted coffee drinks & light lunch fare such as pastries & sandwiches in a stylish space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-e53a-771a-bafc-837d09d9aae8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-e53a-771a-bafc-837d09d9aae8",
        "storage_key": "property/6767906449166986/019cfde3-e53a-771a-bafc-837d09d9aae8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sisterscoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11743872321671219202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sisters-coffee-company---old-mill",
      "poi_latitude": "44.0453911",
      "poi_longitude": "-121.3153499",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 458-206-7114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3a47-771e-b289-9d85ff5a1562.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3a47-771e-b289-9d85ff5a1562",
        "storage_key": "property/6767906449166986/019cfde4-3a47-771e-b289-9d85ff5a1562.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJM5nrL93HuFQRAkjBpKed-qI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_25d9fd14205062071bfb7367",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Jackson's Corner - Old Bend",
      "poi_type": "Restaurants",
      "poi_address": "845 NW Delaware Ave, Bend, OR 97703, USA",
      "poi_short_description": "Easygoing all-day stop for local, seasonal meals with sidewalk seating & a kids' play structure.",
      "poi_long_description": "Easygoing all-day stop for local, seasonal meals with sidewalk seating & a kids' play structure.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-e552-774a-8fe6-4053d2cf7df2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-e552-774a-8fe6-4053d2cf7df2",
        "storage_key": "property/6767906449166986/019cfde3-e552-774a-8fe6-4053d2cf7df2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.jacksonscornerbend.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16094575148923982313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jacksons-corner---old-bend",
      "poi_latitude": "44.0530237",
      "poi_longitude": "-121.3185707",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 541-647-2198",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3a3f-712e-8e41-dadf68d0741e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3a3f-712e-8e41-dadf68d0741e",
        "storage_key": "property/6767906449166986/019cfde4-3a3f-712e-8e41-dadf68d0741e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL-ph3CvGuFQR6ZFxQtNqW98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_08bb7fae9a03c1dc7a92e4de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Pastini",
      "poi_type": "Restaurants",
      "poi_address": "375 SW Powerhouse Dr #3436, Bend, OR 97702, USA",
      "poi_short_description": "Local Italian bistro chain specializing in classic & contemporary pastas, with gluten-free options.",
      "poi_long_description": "Local Italian bistro chain specializing in classic & contemporary pastas, with gluten-free options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-e521-70ef-b7b3-0a062bd88fbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-e521-70ef-b7b3-0a062bd88fbe",
        "storage_key": "property/6767906449166986/019cfde3-e521-70ef-b7b3-0a062bd88fbe.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.pastini.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10703992497248884085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pastini",
      "poi_latitude": "44.0471186",
      "poi_longitude": "-121.315865",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 541-749-1060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3a3f-712e-8e41-dadf68d0741e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3a3f-712e-8e41-dadf68d0741e",
        "storage_key": "property/6767906449166986/019cfde4-3a3f-712e-8e41-dadf68d0741e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqd3pvzLGuFQRdVX3zHY4jJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_97c4eb0e09ac8a7d1d9b0a7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Greg's Grill",
      "poi_type": "Restaurants",
      "poi_address": "395 SW Powerhouse Dr, Bend, OR 97702, USA",
      "poi_short_description": "Sprawling woodsy-chic American restaurant on the Deschutes River specializing in wood-fired meats.",
      "poi_long_description": "Sprawling woodsy-chic American restaurant on the Deschutes River specializing in wood-fired meats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-e552-774a-8fe6-452b8359a617.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-e552-774a-8fe6-452b8359a617",
        "storage_key": "property/6767906449166986/019cfde3-e552-774a-8fe6-452b8359a617.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://gregsgrill.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=15915697400442158112&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gregs-grill",
      "poi_latitude": "44.0466532",
      "poi_longitude": "-121.3159255",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 541-382-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3a3f-712e-8e41-dadf68d0741e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3a3f-712e-8e41-dadf68d0741e",
        "storage_key": "property/6767906449166986/019cfde4-3a3f-712e-8e41-dadf68d0741e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB0zyvzLGuFQRIHz28XXq39w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_1232764066f06406b2bfc6ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Anthony's at the Old Mill District",
      "poi_type": "Restaurants",
      "poi_address": "475 SW Powerhouse Dr, Bend, OR 97702, USA",
      "poi_short_description": "Down-to-earth Pacific Northwest-based seafood chain serving a menu of hearty local catches.",
      "poi_long_description": "Down-to-earth Pacific Northwest-based seafood chain serving a menu of hearty local catches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-e9d8-76d9-bf02-cf7269f8baae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-e9d8-76d9-bf02-cf7269f8baae",
        "storage_key": "property/6767906449166986/019cfde3-e9d8-76d9-bf02-cf7269f8baae.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.anthonys.com/restaurant/anthonys-at-the-old-mill-district/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14719001162593360724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anthonys-at-the-old-mill-district",
      "poi_latitude": "44.0454365",
      "poi_longitude": "-121.3159641",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 541-389-8998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3a3f-712e-8e41-dadf68d0741e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3a3f-712e-8e41-dadf68d0741e",
        "storage_key": "property/6767906449166986/019cfde4-3a3f-712e-8e41-dadf68d0741e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ79-swTLGuFQRVFvwoJJlRMw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_01db324a6dd80dae4b5d4cdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Hola! Old Mill",
      "poi_type": "Restaurants",
      "poi_address": "680 SW Powerhouse Dr #1002, Bend, OR 97702, USA",
      "poi_short_description": "Lively eatery with Mexican-Peruvian fare & a bar with lots of tequila for margaritas.",
      "poi_long_description": "Lively eatery with Mexican-Peruvian fare & a bar with lots of tequila for margaritas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-eb28-76a1-9104-f45dcb9c6301.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-eb28-76a1-9104-f45dcb9c6301",
        "storage_key": "property/6767906449166986/019cfde3-eb28-76a1-9104-f45dcb9c6301.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "http://www.bendhola.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1506206881438319701&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hola-old-mill",
      "poi_latitude": "44.0445314",
      "poi_longitude": "-121.314299",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 541-647-2711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3a3f-712e-8e41-dadf68d0741e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3a3f-712e-8e41-dadf68d0741e",
        "storage_key": "property/6767906449166986/019cfde4-3a3f-712e-8e41-dadf68d0741e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI-bEMDPGuFQRVURhri0f5xQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_41ebc3320ad0831d486bdfde",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Crux Fermentation Project",
      "poi_type": "Restaurants",
      "poi_address": "50 SW Division St, Bend, OR 97702, USA",
      "poi_short_description": "Brewpub set in a former transmission repair plant with 20+ taps, bar food & a patio with fire pit.",
      "poi_long_description": "Brewpub set in a former transmission repair plant with 20+ taps, bar food & a patio with fire pit.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-ea02-761c-8d35-eba2884f5be7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-ea02-761c-8d35-eba2884f5be7",
        "storage_key": "property/6767906449166986/019cfde3-ea02-761c-8d35-eba2884f5be7.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://cruxfermentation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5019213620313342925&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crux-fermentation-project",
      "poi_latitude": "44.0508101",
      "poi_longitude": "-121.3079237",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 541-385-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3a3f-712e-8e41-df29593561b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3a3f-712e-8e41-df29593561b4",
        "storage_key": "property/6767906449166986/019cfde4-3a3f-712e-8e41-df29593561b4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCf5w6i_GuFQRzUOU2jHUp0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "ec_0ee58eb6fc840b0c518cdcff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Deschutes Brewery Bend Public House",
      "poi_type": "Restaurants",
      "poi_address": "1044 NW Bond St, Bend, OR 97703, USA",
      "poi_short_description": "Offshoot brewpub of well-known craft brewery offering locavore fare for lunch & dinner.",
      "poi_long_description": "Offshoot brewpub of well-known craft brewery offering locavore fare for lunch & dinner.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-eb17-77f3-b205-82cdee3d2285.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-eb17-77f3-b205-82cdee3d2285",
        "storage_key": "property/6767906449166986/019cfde3-eb17-77f3-b205-82cdee3d2285.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.deschutesbrewery.com/visit-us/bend-public-house/?y_source=1_MzI3NjAwNjgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2892439571107412155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deschutes-brewery-bend-public-house",
      "poi_latitude": "44.0593408",
      "poi_longitude": "-121.3113704",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 541-382-9242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3a3f-712e-8e41-df29593561b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3a3f-712e-8e41-df29593561b4",
        "storage_key": "property/6767906449166986/019cfde4-3a3f-712e-8e41-df29593561b4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkw7Pmp3IuFQRu_gjEncCJCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "ec_733e04faa2ed26c656106385",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Zydeco Kitchen & Cocktails",
      "poi_type": "Restaurants",
      "poi_address": "919 NW Bond St, Bend, OR 97701, USA",
      "poi_short_description": "Casual restaurant & bar with a patio serving meaty, Cajun-influenced American fare.",
      "poi_long_description": "Casual restaurant & bar with a patio serving meaty, Cajun-influenced American fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-efd7-77dc-b2b2-a47eb5b16243.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-efd7-77dc-b2b2-a47eb5b16243",
        "storage_key": "property/6767906449166986/019cfde3-efd7-77dc-b2b2-a47eb5b16243.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.zydecokitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5399827483055925987&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zydeco-kitchen--cocktails",
      "poi_latitude": "44.058596",
      "poi_longitude": "-121.313118",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 541-312-2899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3a3f-712e-8e41-dadf68d0741e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3a3f-712e-8e41-dadf68d0741e",
        "storage_key": "property/6767906449166986/019cfde4-3a3f-712e-8e41-dadf68d0741e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJj3pjYJ3IuFQR46rwf3wK8Eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_38ac938d50c4b2beab3e3536",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Bonta Gelato - Downtown Bend",
      "poi_type": "Restaurants",
      "poi_address": "920 NW Bond St #108, Bend, OR 97703, USA",
      "poi_short_description": "An array of classic & creative gelato flavors & toppings in a bright, family-friendly setting.",
      "poi_long_description": "An array of classic & creative gelato flavors & toppings in a bright, family-friendly setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-efdb-7003-8366-4fcddf4dc26e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-efdb-7003-8366-4fcddf4dc26e",
        "storage_key": "property/6767906449166986/019cfde3-efdb-7003-8366-4fcddf4dc26e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bontagelato.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1103169173271463471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonta-gelato---downtown-bend",
      "poi_latitude": "44.0580333",
      "poi_longitude": "-121.3125631",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 541-897-9282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3a3f-712e-8e41-dadf68d0741e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3a3f-712e-8e41-dadf68d0741e",
        "storage_key": "property/6767906449166986/019cfde4-3a3f-712e-8e41-dadf68d0741e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSyFLiifGuFQRL8YBrIQ-Tw8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "ec_8241f1b1eca2d64843c0accd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Pine Tavern Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "967 NW Brooks St, Bend, OR 97701, USA",
      "poi_short_description": "Old-school American kitchen & bar, opened in 1936, with a ponderosa pine growing in one dining room.",
      "poi_long_description": "Old-school American kitchen & bar, opened in 1936, with a ponderosa pine growing in one dining room.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-efff-765c-9a92-d6deed88a4ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-efff-765c-9a92-d6deed88a4ea",
        "storage_key": "property/6767906449166986/019cfde3-efff-765c-9a92-d6deed88a4ea.webp",
        "width": 709,
        "height": 464
      },
      "poi_business_url": "http://www.pinetavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11573232177056563676&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pine-tavern-restaurant",
      "poi_latitude": "44.060145",
      "poi_longitude": "-121.314289",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 541-382-5581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3a3f-712e-8e41-dadf68d0741e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3a3f-712e-8e41-dadf68d0741e",
        "storage_key": "property/6767906449166986/019cfde4-3a3f-712e-8e41-dadf68d0741e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtUQSHZ3IuFQR3MGT8FhhnKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_d6dea8436fc6c95688491c30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Ariana Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1304 NW Galveston Ave, Bend, OR 97703, USA",
      "poi_short_description": "Inventive New American cuisine & house cocktails are offered in a cozy Craftsman bungalow.",
      "poi_long_description": "Inventive New American cuisine & house cocktails are offered in a cozy Craftsman bungalow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-f032-7660-8485-23f5fed481dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-f032-7660-8485-23f5fed481dc",
        "storage_key": "property/6767906449166986/019cfde3-f032-7660-8485-23f5fed481dc.webp",
        "width": 690,
        "height": 517
      },
      "poi_business_url": "http://www.arianarestaurantbend.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9909300526384020161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ariana-restaurant",
      "poi_latitude": "44.05682059999999",
      "poi_longitude": "-121.3303409",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 541-330-5539",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3a3f-712e-8e41-dadf68d0741e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3a3f-712e-8e41-dadf68d0741e",
        "storage_key": "property/6767906449166986/019cfde4-3a3f-712e-8e41-dadf68d0741e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY1P1oIDIuFQRwfq1t1PohIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "ec_e915e50c5f223ebb17aeeb7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "McMenamins Pub at Old St. Francis School",
      "poi_type": "Restaurants",
      "poi_address": "700 NW Bond St, Bend, OR 97703, USA",
      "poi_short_description": "Cabinlike spot in McMenamins' St. Francis School for all-day American fare, house beers & a patio.",
      "poi_long_description": "Cabinlike spot in McMenamins' St. Francis School for all-day American fare, house beers & a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-f463-73fe-89fc-cb66228cd6c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-f463-73fe-89fc-cb66228cd6c9",
        "storage_key": "property/6767906449166986/019cfde3-f463-73fe-89fc-cb66228cd6c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mcmenamins.com/old-st-francis-school/old-st-francis-pub",
      "poi_directions_map_url": "https://maps.google.com/?cid=221715453815825799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcmenamins-pub-at-old-st-francis-school",
      "poi_latitude": "44.056659",
      "poi_longitude": "-121.3145183",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 541-330-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3a3f-712e-8e41-df29593561b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3a3f-712e-8e41-df29593561b4",
        "storage_key": "property/6767906449166986/019cfde4-3a3f-712e-8e41-df29593561b4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJicIYEyjGuFQRhyXo0QexEwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "ec_ad2688f32a8e490371ebb79d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Bend Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "1019 NW Brooks St, Bend, OR 97701, USA",
      "poi_short_description": "Craft brewery featuring a pub for pints of beer plus a full menu of American fare.",
      "poi_long_description": "Craft brewery featuring a pub for pints of beer plus a full menu of American fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-f53b-762f-aaef-68c248e86a77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-f53b-762f-aaef-68c248e86a77",
        "storage_key": "property/6767906449166986/019cfde3-f53b-762f-aaef-68c248e86a77.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bendbrewingco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15052450052543594142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bend-brewing-company",
      "poi_latitude": "44.060419",
      "poi_longitude": "-121.3138699",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 541-383-1599",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3a3f-712e-8e41-df29593561b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3a3f-712e-8e41-df29593561b4",
        "storage_key": "property/6767906449166986/019cfde4-3a3f-712e-8e41-df29593561b4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnQPoAZ3IuFQRnr4rTZIL5dA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "ec_a895afa71035523447936d76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Lady Bird Cultural Society",
      "poi_type": "Restaurants",
      "poi_address": "375 SW Powerhouse Dr #130, Bend, OR 97702, USA",
      "poi_short_description": "Wood-fired pizza, burgers and seafood such as scallops, plus cocktails and wine, in plush surroundings.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-f416-75bd-9298-79a6d0b15307.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-f416-75bd-9298-79a6d0b15307",
        "storage_key": "property/6767906449166986/019cfde3-f416-75bd-9298-79a6d0b15307.webp",
        "width": 433,
        "height": 436
      },
      "poi_business_url": "http://ladybirdbend.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7668648667061133423&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lady-bird-cultural-society",
      "poi_latitude": "44.0472222",
      "poi_longitude": "-121.3155556",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 541-382-8345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3a3f-712e-8e41-dadf68d0741e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3a3f-712e-8e41-dadf68d0741e",
        "storage_key": "property/6767906449166986/019cfde4-3a3f-712e-8e41-dadf68d0741e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe_2XpevHuFQRb6BzG1WDbGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_a3a9372b7e639660a6c531aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Market of Choice Bend",
      "poi_type": "Shopping & Retail",
      "poi_address": "115 NW Sisemore St, Bend, OR 97701, USA",
      "poi_short_description": "Market with a standard selection of groceries plus on-site kitchens with sandwiches & prepared food.",
      "poi_long_description": "Market with a standard selection of groceries plus on-site kitchens with sandwiches & prepared food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-f51b-73c8-9fa8-b05786c1fea0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-f51b-73c8-9fa8-b05786c1fea0",
        "storage_key": "property/6767906449166986/019cfde3-f51b-73c8-9fa8-b05786c1fea0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://marketofchoice.com/locations-bend/",
      "poi_directions_map_url": "https://maps.google.com/?cid=682129520769529877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "market-of-choice-bend",
      "poi_latitude": "44.0520703",
      "poi_longitude": "-121.313029",
      "poi_miles_from_property": "472 ft",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 541-382-5828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3a47-771e-b289-9a8b28840c9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3a47-771e-b289-9a8b28840c9d",
        "storage_key": "property/6767906449166986/019cfde4-3a47-771e-b289-9a8b28840c9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmSzWNi_GuFQRFXhGYC9pdwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_a119a1686379df3ee51d1b64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Old Mill District",
      "poi_type": "Shopping & Retail",
      "poi_address": "520 SW Powerhouse Dr #624, Bend, OR 97702, USA",
      "poi_short_description": "Historic mill buildings turned outdoor retail mall with shops, restaurants & a riverside trail.",
      "poi_long_description": "Historic mill buildings turned outdoor retail mall with shops, restaurants & a riverside trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-f8c7-73da-887a-190cb5f91631.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-f8c7-73da-887a-190cb5f91631",
        "storage_key": "property/6767906449166986/019cfde3-f8c7-73da-887a-190cb5f91631.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.oldmilldistrict.com/?utm_source=GoogleMyBusiness&utm_medium=listing&utm_campaign=organic_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=14021848809738570992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-mill-district",
      "poi_latitude": "44.044914",
      "poi_longitude": "-121.3150438",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 541-312-0131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3d85-75dc-a404-a197667aec02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3d85-75dc-a404-a197667aec02",
        "storage_key": "property/6767906449166986/019cfde4-3d85-75dc-a404-a197667aec02.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ84JrwTLGuFQR8IyzljOdl8I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_7f64c0bfd92de9195d5062eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Box Factory",
      "poi_type": "Shopping & Retail",
      "poi_address": "550 SW Industrial Way, Bend, OR 97702, USA",
      "poi_short_description": "Factory-themed area offering a variety of eats and drinks, along with an array of shops and services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-f970-77fa-b647-312b1534068d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-f970-77fa-b647-312b1534068d",
        "storage_key": "property/6767906449166986/019cfde3-f970-77fa-b647-312b1534068d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://boxfactorybend.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18001151142972073159&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "box-factory",
      "poi_latitude": "44.050967",
      "poi_longitude": "-121.315044",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3d85-75dc-a404-a197667aec02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3d85-75dc-a404-a197667aec02",
        "storage_key": "property/6767906449166986/019cfde4-3d85-75dc-a404-a197667aec02.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJX2MZF0DHuFQRx6T3IJfv0Pk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_8853dd6c4036e748aad75ee7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "320 W Century Blvd, Bend, OR 97702, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-f95f-72cf-968d-2a8e185603f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-f95f-72cf-968d-2a8e185603f7",
        "storage_key": "property/6767906449166986/019cfde3-f95f-72cf-968d-2a8e185603f7.webp",
        "width": 748,
        "height": 421
      },
      "poi_business_url": "https://local.safeway.com/safeway/or/bend/320-w-century-blvd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16246414765213804956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "44.0471572",
      "poi_longitude": "-121.3296966",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 541-389-0085",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3a47-771e-b289-9a8b28840c9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3a47-771e-b289-9a8b28840c9d",
        "storage_key": "property/6767906449166986/019cfde4-3a47-771e-b289-9a8b28840c9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRV9wYNDHuFQRnOk62ibcduE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_b443a9a504755ba800728613",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Grocery Outlet",
      "poi_type": "Shopping & Retail",
      "poi_address": "694-B SE 3rd St, Bend, OR 97702, USA",
      "poi_short_description": "Discount chain carrying brand-name groceries, plus items like gifts & toys (many sell beer & wine).",
      "poi_long_description": "Discount chain carrying brand-name groceries, plus items like gifts & toys (many sell beer & wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-fa10-77ef-a11f-60ecfefda538.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-fa10-77ef-a11f-60ecfefda538",
        "storage_key": "property/6767906449166986/019cfde3-fa10-77ef-a11f-60ecfefda538.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.groceryoutlet.com/circulars/storeid/79",
      "poi_directions_map_url": "https://maps.google.com/?cid=8620757679409894669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grocery-outlet",
      "poi_latitude": "44.0435393",
      "poi_longitude": "-121.3010507",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 541-389-3095",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3a47-771e-b289-9a8b28840c9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3a47-771e-b289-9a8b28840c9d",
        "storage_key": "property/6767906449166986/019cfde4-3a47-771e-b289-9a8b28840c9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnVPnrDfGuFQRDZXyR28Vo3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_a532fdbe4ed9504e19863796",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "61535 S Hwy 97, Bend, OR 97702, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-fcb8-7647-8731-c1593595aee7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-fcb8-7647-8731-c1593595aee7",
        "storage_key": "property/6767906449166986/019cfde3-fcb8-7647-8731-c1593595aee7.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/or/bend/bend/701/00021?cid=loc_70100021_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=696241955448083089&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "44.0349212",
      "poi_longitude": "-121.3089338",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 541-385-6667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3a47-771e-b289-9a8b28840c9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3a47-771e-b289-9a8b28840c9d",
        "storage_key": "property/6767906449166986/019cfde4-3a47-771e-b289-9a8b28840c9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh190c7THuFQRkdI0oF6MqQk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_e4fbde003f7d2a8aa0a0b1a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "63435 N Hwy 97, Bend, OR 97703, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-fdd6-732b-a61c-5e5d31d00777.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-fdd6-732b-a61c-5e5d31d00777",
        "storage_key": "property/6767906449166986/019cfde3-fdd6-732b-a61c-5e5d31d00777.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/bend/766",
      "poi_directions_map_url": "https://maps.google.com/?cid=10637148137445770862&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "44.1043034",
      "poi_longitude": "-121.300913",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 541-330-1434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3d85-75dc-a404-a197667aec02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3d85-75dc-a404-a197667aec02",
        "storage_key": "property/6767906449166986/019cfde4-3d85-75dc-a404-a197667aec02.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGSTAONjOuFQRbsape9-9npM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_3f8849233351094ba3ef6b89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "20120 Pinebrook Blvd, Bend, OR 97702, USA",
      "poi_short_description": "Chain retailer supplying an array of merchandise, including clothing, housewares, electronics, and groceries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-fe49-74ce-9803-6538c79b09d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-fe49-74ce-9803-6538c79b09d6",
        "storage_key": "property/6767906449166986/019cfde3-fe49-74ce-9803-6538c79b09d6.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2075-bend-or/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14212151995125020568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "44.023804",
      "poi_longitude": "-121.3173587",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 541-389-8184",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3d85-75dc-a404-a197667aec02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3d85-75dc-a404-a197667aec02",
        "storage_key": "property/6767906449166986/019cfde4-3d85-75dc-a404-a197667aec02.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJp4i9l6PHuFQRmDdJu_C0O8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_c904365144148061f333c983",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "256 NE Franklin Ave, Bend, OR 97701, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-fe34-72d7-9642-bce8331aec35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-fe34-72d7-9642-bce8331aec35",
        "storage_key": "property/6767906449166986/019cfde3-fe34-72d7-9642-bce8331aec35.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.7-eleven.com/locations/or/bend/256-n.e.-franklin-ave.-27233?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4181646447593414914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "44.05634939999999",
      "poi_longitude": "-121.303058",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 541-389-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3dc4-75ad-980b-8bd6a2f30d59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3dc4-75ad-980b-8bd6a2f30d59",
        "storage_key": "property/6767906449166986/019cfde4-3dc4-75ad-980b-8bd6a2f30d59.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJG5sKWCHGuFQRAmEU7UkxCDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_ebb6a24b8e72a4b32f0a6e04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "223 NE Franklin Ave, Bend, OR 97701, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-015a-77f8-a3c0-9668c9538da2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-015a-77f8-a3c0-9668c9538da2",
        "storage_key": "property/6767906449166986/019cfde4-015a-77f8-a3c0-9668c9538da2.webp",
        "width": 900,
        "height": 492
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-223+ne+franklin+ave-bend-or-97701/id=15674",
      "poi_directions_map_url": "https://maps.google.com/?cid=18304252229917775066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "44.0556455",
      "poi_longitude": "-121.3030744",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 541-633-4469",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3dee-7398-a565-fcf284814efe",
        "storage_key": "property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh6CA-CPGuFQR2pRmS2zEBf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_1f36ba48497a3c9e215d570e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Amity Creek Magnet at Thompson School",
      "poi_type": "Education",
      "poi_address": "437 NW Wall St, Bend, OR 97703, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-0232-73e4-af1e-6592193dfb1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-0232-73e4-af1e-6592193dfb1c",
        "storage_key": "property/6767906449166986/019cfde4-0232-73e4-af1e-6592193dfb1c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bend.k12.or.us/amity",
      "poi_directions_map_url": "https://maps.google.com/?cid=14879153717144058315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amity-creek-magnet-at-thompson-school",
      "poi_latitude": "44.0553691",
      "poi_longitude": "-121.3177918",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 541-355-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3def-737f-9eca-4f397e3c1627",
        "storage_key": "property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUeXnlCnGuFQRy_nN_Hhffc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_d3e6c10c96eafb72b31f9fa1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Bear Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "51 NE 13th St, Bend, OR 97702, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bend.k12.or.us/bearcreek",
      "poi_directions_map_url": "https://maps.google.com/?cid=2302081969864697491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-creek-elementary-school",
      "poi_latitude": "44.0506129",
      "poi_longitude": "-121.2869561",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 541-355-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3def-737f-9eca-4f397e3c1627",
        "storage_key": "property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx7r4jRXGuFQRk-adyVqj8h8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_2cf29cfe7a69505db6a08e4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Highland Magnet School at Kenwood School",
      "poi_type": "Education",
      "poi_address": "701 NW Newport Ave, Bend, OR 97703, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-02a3-743c-b8a4-d5efa06561c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-02a3-743c-b8a4-d5efa06561c1",
        "storage_key": "property/6767906449166986/019cfde4-02a3-743c-b8a4-d5efa06561c1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bend.k12.or.us/highland",
      "poi_directions_map_url": "https://maps.google.com/?cid=5418820120388938224&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "highland-magnet-school-at-kenwood-school",
      "poi_latitude": "44.0620916",
      "poi_longitude": "-121.3227887",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 541-355-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3def-737f-9eca-4f397e3c1627",
        "storage_key": "property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH0Tv7YTIuFQR8KmFeTCEM0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_1477c801e8c001b6a753d2bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Westside Village Magnet School at Kingston Elementary",
      "poi_type": "Education",
      "poi_address": "1101 NW 12th St, Bend, OR 97703, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-0292-767c-bd9d-ab364dbfc378.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-0292-767c-bd9d-ab364dbfc378",
        "storage_key": "property/6767906449166986/019cfde4-0292-767c-bd9d-ab364dbfc378.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bend.k12.or.us/westside",
      "poi_directions_map_url": "https://maps.google.com/?cid=10922015552463628115&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westside-village-magnet-school-at-kingston-elementary",
      "poi_latitude": "44.0603118",
      "poi_longitude": "-121.3293654",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 541-355-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3def-737f-9eca-4f397e3c1627",
        "storage_key": "property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeaTW44bIuFQRU-fiE0fLkpc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_e81f21b202ca85c0cbd35af1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Bend Senior High School",
      "poi_type": "Education",
      "poi_address": "230 NE 6th St Rm S-19 S-19, Bend, OR 97701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-062c-726e-b7b7-7b1c03e3e159.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-062c-726e-b7b7-7b1c03e3e159",
        "storage_key": "property/6767906449166986/019cfde4-062c-726e-b7b7-7b1c03e3e159.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bend.k12.or.us/bendhigh",
      "poi_directions_map_url": "https://maps.google.com/?cid=901416600491179072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bend-senior-high-school",
      "poi_latitude": "44.0524142",
      "poi_longitude": "-121.2955438",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 541-355-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3def-737f-9eca-4f397e3c1627",
        "storage_key": "property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW_8IMiPGuFQRQLzqSp95ggw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_05b14b43190d8ddab4c78282",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Marshall High School",
      "poi_type": "Education",
      "poi_address": "1291 NE 5th St, Bend, OR 97701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bend.k12.or.us/marshall",
      "poi_directions_map_url": "https://maps.google.com/?cid=14130787050133342821&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marshall-high-school",
      "poi_latitude": "44.0624056",
      "poi_longitude": "-121.299292",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 541-355-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3def-737f-9eca-4f397e3c1627",
        "storage_key": "property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrbiz0R_GuFQRZUrjN_SjGsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_7266641ff06fdd342fd82165",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Oregon State University-Cascades",
      "poi_type": "Education",
      "poi_address": "1500 SW Chandler Ave, Bend, OR 97702, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-0654-74ff-9a61-ef8ed8a3fa01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-0654-74ff-9a61-ef8ed8a3fa01",
        "storage_key": "property/6767906449166986/019cfde4-0654-74ff-9a61-ef8ed8a3fa01.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://osucascades.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17728967412679668300&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oregon-state-university-cascades",
      "poi_latitude": "44.0433055",
      "poi_longitude": "-121.334255",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 541-322-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3def-737f-9eca-4f397e3c1627",
        "storage_key": "property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeTv9UvbIuFQRTHI_A-7xCfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_ade2b4179225d9a863e52f6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Central Oregon Community College",
      "poi_type": "Education",
      "poi_address": "2600 NW College Way, Bend, OR 97703, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-0722-714c-812e-dab746a7f0ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-0722-714c-812e-dab746a7f0ea",
        "storage_key": "property/6767906449166986/019cfde4-0722-714c-812e-dab746a7f0ea.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.cocc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14323501484613636672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-oregon-community-college",
      "poi_latitude": "44.0676288",
      "poi_longitude": "-121.3470916",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 541-383-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3def-737f-9eca-4f397e3c1627",
        "storage_key": "property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeTv9UvbIuFQRQBItCrZMx8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_2b02a9059d8576e0f7beb8d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Growing Tree",
      "poi_type": "Education",
      "poi_address": "1080 NE 4th St, Bend, OR 97701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-0778-751c-8c12-ab988b34509e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-0778-751c-8c12-ab988b34509e",
        "storage_key": "property/6767906449166986/019cfde4-0778-751c-8c12-ab988b34509e.webp",
        "width": 1280,
        "height": 663
      },
      "poi_business_url": "http://thegrowingtree.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11206254439958482231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "growing-tree",
      "poi_latitude": "44.0606786",
      "poi_longitude": "-121.3003397",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 541-388-3733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3dee-7398-a565-fcf284814efe",
        "storage_key": "property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4X5S-B_GuFQRN41eNAqdhJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_40d86ce78efa3fdcc3369ca2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Cottage Day Care Inc",
      "poi_type": "Education",
      "poi_address": "1415 NE Williamson Blvd, Bend, OR 97701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-0b6f-7098-80d9-beb1fd62763a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-0b6f-7098-80d9-beb1fd62763a",
        "storage_key": "property/6767906449166986/019cfde4-0b6f-7098-80d9-beb1fd62763a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cottagedaycare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3699217544678721275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cottage-day-care-inc",
      "poi_latitude": "44.0640303",
      "poi_longitude": "-121.271054",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 541-389-7380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3def-737f-9eca-4f397e3c1627",
        "storage_key": "property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT_o0fQfGuFQR-8Z38cFCVjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_7538b8c00c8cdd4362e540ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Tin Pan Theater",
      "poi_type": "Entertainment",
      "poi_address": "869 NW Tin Pan Alley, Bend, OR 97703, USA",
      "poi_short_description": "Small, single-screen, kid-friendly art-house cinema with beer & snack bar & lineup of unique films.",
      "poi_long_description": "Small, single-screen, kid-friendly art-house cinema with beer & snack bar & lineup of unique films.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-0b0f-76f4-97af-7c057b7292f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-0b0f-76f4-97af-7c057b7292f8",
        "storage_key": "property/6767906449166986/019cfde4-0b0f-76f4-97af-7c057b7292f8.webp",
        "width": 1280,
        "height": 473
      },
      "poi_business_url": "https://www.tinpantheater.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12727555141481240808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tin-pan-theater",
      "poi_latitude": "44.05776789999999",
      "poi_longitude": "-121.3127797",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 541-388-3378",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-4150-7408-ab68-5e288af60bc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-4150-7408-ab68-5e288af60bc9",
        "storage_key": "property/6767906449166986/019cfde4-4150-7408-ab68-5e288af60bc9.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJRXsj8CfGuFQR6Jgvu_dbobA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_2aae80e4fda939df0cc0a29a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Tower Theatre",
      "poi_type": "Entertainment",
      "poi_address": "835 NW Wall St, Bend, OR 97703, USA",
      "poi_short_description": "Music & live theater venue in a landmark circa-1940 former cinema with a 78-ft. neon sign.",
      "poi_long_description": "Music & live theater venue in a landmark circa-1940 former cinema with a 78-ft. neon sign.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-0c56-77b9-9184-1a7d34324c7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-0c56-77b9-9184-1a7d34324c7e",
        "storage_key": "property/6767906449166986/019cfde4-0c56-77b9-9184-1a7d34324c7e.webp",
        "width": 854,
        "height": 1280
      },
      "poi_business_url": "https://www.towertheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9271753599712496231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tower-theatre",
      "poi_latitude": "44.0587081",
      "poi_longitude": "-121.314888",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 541-317-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3dee-7398-a565-fcf284814efe",
        "storage_key": "property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEQt1SZ3IuFQRZwrQa8biq4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_b1d11fda60701d55337f281d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Volcanic Theatre Pub",
      "poi_type": "Entertainment",
      "poi_address": "70 SW Century Dr, Bend, OR 97702, USA",
      "poi_short_description": "Intimate theater with comfy sofa seating & local beers offering an eclectic mix of entertainment.",
      "poi_long_description": "Intimate theater with comfy sofa seating & local beers offering an eclectic mix of entertainment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-0bfb-7516-95d2-b077bd075493.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-0bfb-7516-95d2-b077bd075493",
        "storage_key": "property/6767906449166986/019cfde4-0bfb-7516-95d2-b077bd075493.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.volcanictheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6958866094920458973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "volcanic-theatre-pub",
      "poi_latitude": "44.0508587",
      "poi_longitude": "-121.3305861",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 541-323-1881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3dee-7398-a565-fcf284814efe",
        "storage_key": "property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCYy00dXHuFQR3WI--9fbkmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_9acf92e48d2e0c2044cfed32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "High Desert Museum",
      "poi_type": "Entertainment",
      "poi_address": "59800 S Hwy 97, Bend, OR 97702, USA",
      "poi_short_description": "Hands-on, kid-friendly museum showcasing the natural & cultural history of Eastern Oregon.",
      "poi_long_description": "Hands-on, kid-friendly museum showcasing the natural & cultural history of Eastern Oregon.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-0f95-725a-832b-46db28ea03b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-0f95-725a-832b-46db28ea03b5",
        "storage_key": "property/6767906449166986/019cfde4-0f95-725a-832b-46db28ea03b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.highdesertmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15099246530244806092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "high-desert-museum",
      "poi_latitude": "43.9661759",
      "poi_longitude": "-121.3419191",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 541-382-4754",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-4170-7326-bbe5-ec30dd627199.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-4170-7326-bbe5-ec30dd627199",
        "storage_key": "property/6767906449166986/019cfde4-4170-7326-bbe5-ec30dd627199.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJHxaqlS2_uFQRzIVKU7hMi9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_ba29a73fd81c19a8dd422c20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Hayden Homes Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "344 SW Shevlin Hixon Dr, Bend, OR 97702, USA",
      "poi_short_description": "Independent outdoor concert venue on the Deschutes River presenting national touring acts.",
      "poi_long_description": "Independent outdoor concert venue on the Deschutes River presenting national touring acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-114a-708a-b0b7-914f0b3ca79a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-114a-708a-b0b7-914f0b3ca79a",
        "storage_key": "property/6767906449166986/019cfde4-114a-708a-b0b7-914f0b3ca79a.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.bendconcerts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13554397280674415007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hayden-homes-amphitheater",
      "poi_latitude": "44.0470973",
      "poi_longitude": "-121.3181815",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 541-312-8510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3dee-7398-a565-fcf284814efe",
        "storage_key": "property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPUdyPs3HuFQRn4EeM4PkGrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_46eeec1f70b4ff82f3c7c63f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "McMenamins Pub at Old St. Francis School",
      "poi_type": "Entertainment",
      "poi_address": "700 NW Bond St, Bend, OR 97703, USA",
      "poi_short_description": "Cabinlike spot in McMenamins' St. Francis School for all-day American fare, house beers & a patio.",
      "poi_long_description": "Cabinlike spot in McMenamins' St. Francis School for all-day American fare, house beers & a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-f463-73fe-89fc-cb66228cd6c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-f463-73fe-89fc-cb66228cd6c9",
        "storage_key": "property/6767906449166986/019cfde3-f463-73fe-89fc-cb66228cd6c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mcmenamins.com/old-st-francis-school/old-st-francis-pub",
      "poi_directions_map_url": "https://maps.google.com/?cid=221715453815825799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcmenamins-pub-at-old-st-francis-school",
      "poi_latitude": "44.056659",
      "poi_longitude": "-121.3145183",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 541-330-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3a3f-712e-8e41-df29593561b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3a3f-712e-8e41-df29593561b4",
        "storage_key": "property/6767906449166986/019cfde4-3a3f-712e-8e41-df29593561b4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJicIYEyjGuFQRhyXo0QexEwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "ec_02ba79ab420783b93ae10d4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Deschutes Historical Museum",
      "poi_type": "Entertainment",
      "poi_address": "129 NW Idaho Ave, Bend, OR 97703, USA",
      "poi_short_description": "Housed in a 1914 school, this museum offers exhibits on regional history, artifacts & events.",
      "poi_long_description": "Housed in a 1914 school, this museum offers exhibits on regional history, artifacts & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-100b-7159-ba20-dd8abf993120.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-100b-7159-ba20-dd8abf993120",
        "storage_key": "property/6767906449166986/019cfde4-100b-7159-ba20-dd8abf993120.webp",
        "width": 1280,
        "height": 798
      },
      "poi_business_url": "http://www.deschuteshistory.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8127513966427866676&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deschutes-historical-museum",
      "poi_latitude": "44.0553497",
      "poi_longitude": "-121.3171216",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 541-389-1813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-4170-7326-bbe5-ec30dd627199.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-4170-7326-bbe5-ec30dd627199",
        "storage_key": "property/6767906449166986/019cfde4-4170-7326-bbe5-ec30dd627199.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1SowuinGuFQRNIb1G-S6ynA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_609cdd201bc10659ebfb8805",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Old Mill District",
      "poi_type": "Entertainment",
      "poi_address": "520 SW Powerhouse Dr #624, Bend, OR 97702, USA",
      "poi_short_description": "Historic mill buildings turned outdoor retail mall with shops, restaurants & a riverside trail.",
      "poi_long_description": "Historic mill buildings turned outdoor retail mall with shops, restaurants & a riverside trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-f8c7-73da-887a-190cb5f91631.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-f8c7-73da-887a-190cb5f91631",
        "storage_key": "property/6767906449166986/019cfde3-f8c7-73da-887a-190cb5f91631.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.oldmilldistrict.com/?utm_source=GoogleMyBusiness&utm_medium=listing&utm_campaign=organic_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=14021848809738570992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-mill-district",
      "poi_latitude": "44.044914",
      "poi_longitude": "-121.3150438",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 541-312-0131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3d85-75dc-a404-a197667aec02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3d85-75dc-a404-a197667aec02",
        "storage_key": "property/6767906449166986/019cfde4-3d85-75dc-a404-a197667aec02.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ84JrwTLGuFQR8IyzljOdl8I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_a6efc92856671592e00714f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Box Factory",
      "poi_type": "Entertainment",
      "poi_address": "550 SW Industrial Way, Bend, OR 97702, USA",
      "poi_short_description": "Factory-themed area offering a variety of eats and drinks, along with an array of shops and services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-f970-77fa-b647-312b1534068d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-f970-77fa-b647-312b1534068d",
        "storage_key": "property/6767906449166986/019cfde3-f970-77fa-b647-312b1534068d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://boxfactorybend.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18001151142972073159&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "box-factory",
      "poi_latitude": "44.050967",
      "poi_longitude": "-121.315044",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3d85-75dc-a404-a197667aec02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3d85-75dc-a404-a197667aec02",
        "storage_key": "property/6767906449166986/019cfde4-3d85-75dc-a404-a197667aec02.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJX2MZF0DHuFQRx6T3IJfv0Pk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_f22e3cc08e8923b516e67359",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Drake Park",
      "poi_type": "Entertainment",
      "poi_address": "777 NW Riverside Blvd, Bend, OR 97701, USA",
      "poi_short_description": "13-acre retreat offering a pond, picnic tables, an outdoor stage & nesting great horned owls.",
      "poi_long_description": "13-acre retreat offering a pond, picnic tables, an outdoor stage & nesting great horned owls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-114a-708a-b0b7-953a026e82c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-114a-708a-b0b7-953a026e82c8",
        "storage_key": "property/6767906449166986/019cfde4-114a-708a-b0b7-953a026e82c8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bendparksandrec.org/park/drake-park-and-mirror-pond/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8297115448716905963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "drake-park",
      "poi_latitude": "44.059025",
      "poi_longitude": "-121.318238",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 541-389-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-4186-70ac-86fe-488cb7821ff7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-4186-70ac-86fe-488cb7821ff7",
        "storage_key": "property/6767906449166986/019cfde4-4186-70ac-86fe-488cb7821ff7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0X9o4ILIuFQR600tZYpGJXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f9fe21c5db173b7d3b90b758",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "St. Charles Bend",
      "poi_type": "Health and Wellness",
      "poi_address": "2500 NE Neff Rd, Bend, OR 97701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-153a-7135-9925-c32511e4144d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-153a-7135-9925-c32511e4144d",
        "storage_key": "property/6767906449166986/019cfde4-153a-7135-9925-c32511e4144d.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.stcharleshealthcare.org/locations/st-charles-bend?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=16519677801245240834&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-charles-bend",
      "poi_latitude": "44.06800390000001",
      "poi_longitude": "-121.269589",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 541-382-4321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-41c9-774d-9b46-be8a58d01f9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-41c9-774d-9b46-be8a58d01f9c",
        "storage_key": "property/6767906449166986/019cfde4-41c9-774d-9b46-be8a58d01f9c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJqQ8zPfjFuFQRAu4ga2-vQeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_aff3f06d313f8c7a09c45f8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "BestMed Urgent Care - Bend NE 3rd",
      "poi_type": "Health and Wellness",
      "poi_address": "1302 NE 3rd St, Bend, OR 97701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-1568-7276-a5f6-776f80be7cfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-1568-7276-a5f6-776f80be7cfb",
        "storage_key": "property/6767906449166986/019cfde4-1568-7276-a5f6-776f80be7cfb.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "https://www.bestmedclinics.com/oregon/find-a-clinic/bend-ne-3rd/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13553122736405569124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bestmed-urgent-care---bend-ne-3rd",
      "poi_latitude": "44.0631658",
      "poi_longitude": "-121.3020221",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 541-398-7524",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3dee-7398-a565-fcf284814efe",
        "storage_key": "property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1zvdvHjJuFQRZF65PFJdFrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_e5194b400c118b62d6de205a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "St. Charles Community Pharmacy - Bend",
      "poi_type": "Health and Wellness",
      "poi_address": "2500 NE Neff Rd, Bend, OR 97701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-1688-7289-a015-fc29f482f572.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-1688-7289-a015-fc29f482f572",
        "storage_key": "property/6767906449166986/019cfde4-1688-7289-a015-fc29f482f572.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.stcharleshealthcare.org/locations/community-pharmacy?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=8862451869216843084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-charles-community-pharmacy---bend",
      "poi_latitude": "44.0679885",
      "poi_longitude": "-121.2694821",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 541-706-7731",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-4507-721c-855d-d3ea7bc255c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-4507-721c-855d-d3ea7bc255c3",
        "storage_key": "property/6767906449166986/019cfde4-4507-721c-855d-d3ea7bc255c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB_206_7FuFQRTKWqDwXB_Xo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_4fd06ffc4288db177d596734",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Safeway Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "320 W Century Blvd, Bend, OR 97702, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-f95f-72cf-968d-2a8e185603f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-f95f-72cf-968d-2a8e185603f7",
        "storage_key": "property/6767906449166986/019cfde3-f95f-72cf-968d-2a8e185603f7.webp",
        "width": 748,
        "height": 421
      },
      "poi_business_url": "https://local.pharmacy.safeway.com/safeway/or/bend/320-w-century-blvd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=4536031497620846087&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway-pharmacy",
      "poi_latitude": "44.047005",
      "poi_longitude": "-121.3296308",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 541-389-7184",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-4507-721c-855d-d3ea7bc255c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-4507-721c-855d-d3ea7bc255c3",
        "storage_key": "property/6767906449166986/019cfde4-4507-721c-855d-d3ea7bc255c3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRV9wYNDHuFQRB3asOZ048z4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_5f8899bcb7397fea64cf18f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "223 NE Franklin Ave, Bend, OR 97701, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-015a-77f8-a3c0-9668c9538da2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-015a-77f8-a3c0-9668c9538da2",
        "storage_key": "property/6767906449166986/019cfde4-015a-77f8-a3c0-9668c9538da2.webp",
        "width": 900,
        "height": 492
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-223+ne+franklin+ave-bend-or-97701/id=15674",
      "poi_directions_map_url": "https://maps.google.com/?cid=18304252229917775066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "44.0556455",
      "poi_longitude": "-121.3030744",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 541-633-4469",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3dee-7398-a565-fcf284814efe",
        "storage_key": "property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh6CA-CPGuFQR2pRmS2zEBf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_a825b5dc4dfe2a463dbe6876",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "725 NE Greenwood Ave, Bend, OR 97701, USA",
      "poi_short_description": "Chain fitness center offering tanning, massage chairs, and hydro massages in a laid-back space.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-1994-72ed-a2ba-f13e848f0387.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-1994-72ed-a2ba-f13e848f0387",
        "storage_key": "property/6767906449166986/019cfde4-1994-72ed-a2ba-f13e848f0387.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/bend-or?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=8654775137169959050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "44.0592365",
      "poi_longitude": "-121.2948454",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 541-306-6084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3dee-7398-a565-fcf284814efe",
        "storage_key": "property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN-FoKB_GuFQRiujl3SHwG3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_978f6536fdb176d58fdd5869",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Xcel Fitness Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "2410 NE Twin Knolls Dr, Bend, OR 97701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-1989-7296-a422-e525ee7b679b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-1989-7296-a422-e525ee7b679b",
        "storage_key": "property/6767906449166986/019cfde4-1989-7296-a422-e525ee7b679b.webp",
        "width": 1080,
        "height": 800
      },
      "poi_business_url": "https://www.xcelfitnessbend.com/?utm_source=google&utm_medium=local&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=11535168788365720255&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "xcel-fitness-gym",
      "poi_latitude": "44.053582",
      "poi_longitude": "-121.2680954",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 541-383-3481",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3dee-7398-a565-fcf284814efe",
        "storage_key": "property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyXjXkQzGuFQRvzq2puUmFaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_defe051c1f73e0f25a226361",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Bend Yoga Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1230 NE 3rd St, Bend, OR 97701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-1af6-76fe-92b0-07cbfc9f3ae3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-1af6-76fe-92b0-07cbfc9f3ae3",
        "storage_key": "property/6767906449166986/019cfde4-1af6-76fe-92b0-07cbfc9f3ae3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bendhotyoga.com/?utm_source=Google%20Maps-Locl.io&utm_medium=Website&utm_campaign=Bend%20Hot%20Yoga",
      "poi_directions_map_url": "https://maps.google.com/?cid=5306731832500262633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bend-yoga-center",
      "poi_latitude": "44.0625915",
      "poi_longitude": "-121.3010603",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3def-737f-9eca-4f397e3c1627",
        "storage_key": "property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7Q8wbaDIuFQR6ZZvQnxMpUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_cf31f9c774e057b9791b86cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Bend Yoga Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1230 NE 3rd St, Bend, OR 97701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-1af6-76fe-92b0-07cbfc9f3ae3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-1af6-76fe-92b0-07cbfc9f3ae3",
        "storage_key": "property/6767906449166986/019cfde4-1af6-76fe-92b0-07cbfc9f3ae3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bendhotyoga.com/?utm_source=Google%20Maps-Locl.io&utm_medium=Website&utm_campaign=Bend%20Hot%20Yoga",
      "poi_directions_map_url": "https://maps.google.com/?cid=5306731832500262633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bend-yoga-center",
      "poi_latitude": "44.0625915",
      "poi_longitude": "-121.3010603",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3def-737f-9eca-4f397e3c1627",
        "storage_key": "property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7Q8wbaDIuFQR6ZZvQnxMpUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_edaa4334e5952d4d467ac4a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Juniper Swim & Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "800 NE 6th St, Bend, OR 97701, USA",
      "poi_short_description": "Fitness facility featuring an Olympic pool outdoors and 2 indoor pools, 1 for tots.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-1be3-72da-98e3-19d090ad480f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-1be3-72da-98e3-19d090ad480f",
        "storage_key": "property/6767906449166986/019cfde4-1be3-72da-98e3-19d090ad480f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bendparksandrec.org/facility/juniper-swim-and-fitness-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6077717677904809996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "juniper-swim--fitness-center",
      "poi_latitude": "44.0575359",
      "poi_longitude": "-121.2970126",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 541-389-7665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3dee-7398-a565-fcf284814efe",
        "storage_key": "property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3bJ0qhjGuFQRDNCg5AZkWFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "swimming_pool"
    },
    {
      "id": "ec_755f276988371e64e3e0b51a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Drake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "777 NW Riverside Blvd, Bend, OR 97701, USA",
      "poi_short_description": "13-acre retreat offering a pond, picnic tables, an outdoor stage & nesting great horned owls.",
      "poi_long_description": "13-acre retreat offering a pond, picnic tables, an outdoor stage & nesting great horned owls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-114a-708a-b0b7-953a026e82c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-114a-708a-b0b7-953a026e82c8",
        "storage_key": "property/6767906449166986/019cfde4-114a-708a-b0b7-953a026e82c8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bendparksandrec.org/park/drake-park-and-mirror-pond/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8297115448716905963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "drake-park",
      "poi_latitude": "44.059025",
      "poi_longitude": "-121.318238",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 541-389-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-4186-70ac-86fe-488cb7821ff7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-4186-70ac-86fe-488cb7821ff7",
        "storage_key": "property/6767906449166986/019cfde4-4186-70ac-86fe-488cb7821ff7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0X9o4ILIuFQR600tZYpGJXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_874287a567b297cfd114a91b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Old Mill District",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "520 SW Powerhouse Dr #624, Bend, OR 97702, USA",
      "poi_short_description": "Historic mill buildings turned outdoor retail mall with shops, restaurants & a riverside trail.",
      "poi_long_description": "Historic mill buildings turned outdoor retail mall with shops, restaurants & a riverside trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-f8c7-73da-887a-190cb5f91631.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde3-f8c7-73da-887a-190cb5f91631",
        "storage_key": "property/6767906449166986/019cfde3-f8c7-73da-887a-190cb5f91631.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.oldmilldistrict.com/?utm_source=GoogleMyBusiness&utm_medium=listing&utm_campaign=organic_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=14021848809738570992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-mill-district",
      "poi_latitude": "44.044914",
      "poi_longitude": "-121.3150438",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 541-312-0131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3d85-75dc-a404-a197667aec02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3d85-75dc-a404-a197667aec02",
        "storage_key": "property/6767906449166986/019cfde4-3d85-75dc-a404-a197667aec02.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ84JrwTLGuFQR8IyzljOdl8I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_66e1672510d18365b332b606",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Riverbend Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "799 SW Columbia St, Bend, OR 97702, USA",
      "poi_short_description": "Community riverside gathering place featuring a sandy beach, grassy lawns, trails & regular events.",
      "poi_long_description": "Community riverside gathering place featuring a sandy beach, grassy lawns, trails & regular events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-1ec6-7761-b00f-b4155497bedb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-1ec6-7761-b00f-b4155497bedb",
        "storage_key": "property/6767906449166986/019cfde4-1ec6-7761-b00f-b4155497bedb.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.bendparksandrec.org/park/riverbend-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14658742459981069640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverbend-park",
      "poi_latitude": "44.042778",
      "poi_longitude": "-121.3217887",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 541-389-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-4186-70ac-86fe-488cb7821ff7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-4186-70ac-86fe-488cb7821ff7",
        "storage_key": "property/6767906449166986/019cfde4-4186-70ac-86fe-488cb7821ff7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJITacrs3HuFQRSH0bHZpQbss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_99fdbdc659b1af70ded0b0d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Farewell Bend Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1000 SW Reed Market Rd, Bend, OR 97702, USA",
      "poi_short_description": "Urban park with a lumber mill–themed playground & picnic shelters, plus a boardwalk & boat launch.",
      "poi_long_description": "Urban park with a lumber mill–themed playground & picnic shelters, plus a boardwalk & boat launch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-1efe-742a-91ea-fb04060b6714.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-1efe-742a-91ea-fb04060b6714",
        "storage_key": "property/6767906449166986/019cfde4-1efe-742a-91ea-fb04060b6714.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.bendparksandrec.org/park/farewell-bend-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2655175151812288327&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "farewell-bend-park",
      "poi_latitude": "44.0411386",
      "poi_longitude": "-121.3246087",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 541-389-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-4186-70ac-86fe-488cb7821ff7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-4186-70ac-86fe-488cb7821ff7",
        "storage_key": "property/6767906449166986/019cfde4-4186-70ac-86fe-488cb7821ff7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJN3EwHM_HuFQRRx83nLsT2SQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_5af2e043e07654726d68f955",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Miller's Landing Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "55 NW Riverside Blvd, Bend, OR 97701, USA",
      "poi_short_description": "Waterside park with access to the river & whitewater park, plus grassy areas & a picnic pavilion.",
      "poi_long_description": "Waterside park with access to the river & whitewater park, plus grassy areas & a picnic pavilion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-2200-77aa-bd96-7ccd04d3251c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-2200-77aa-bd96-7ccd04d3251c",
        "storage_key": "property/6767906449166986/019cfde4-2200-77aa-bd96-7ccd04d3251c.webp",
        "width": 1280,
        "height": 1019
      },
      "poi_business_url": "https://www.bendparksandrec.org/park/millers-landing-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12429581930178090825&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "millers-landing-park",
      "poi_latitude": "44.0519183",
      "poi_longitude": "-121.3235809",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 541-389-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-4186-70ac-86fe-488cb7821ff7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-4186-70ac-86fe-488cb7821ff7",
        "storage_key": "property/6767906449166986/019cfde4-4186-70ac-86fe-488cb7821ff7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJI4fJPyvGuFQRSRfhJum-fqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_1fd09fab6b437feb5fa5f3f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "McKay Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "166 SW Shevlin Hixon Dr, Bend, OR 97702, USA",
      "poi_short_description": "This calm, riverfront park offers swimming, fishing, open green areas & sculptures of Canada geese.",
      "poi_long_description": "This calm, riverfront park offers swimming, fishing, open green areas & sculptures of Canada geese.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-23c8-731d-9bb6-972e30f24465.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-23c8-731d-9bb6-972e30f24465",
        "storage_key": "property/6767906449166986/019cfde4-23c8-731d-9bb6-972e30f24465.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bendparksandrec.org/park/mckay-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2293314930408207402&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckay-park",
      "poi_latitude": "44.049949",
      "poi_longitude": "-121.3216727",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 541-389-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-4186-70ac-86fe-488cb7821ff7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-4186-70ac-86fe-488cb7821ff7",
        "storage_key": "property/6767906449166986/019cfde4-4186-70ac-86fe-488cb7821ff7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZz5fVdPHuFQRKrQUWcd90x8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_b60fb305941fb19a188bc87e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Bend Whitewater Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "166 SW Shevlin Hixon Dr, Bend, OR 97702, USA",
      "poi_short_description": "Churning river offering 3 water channels with various rapid levels for tubing, surfing & kayaking.",
      "poi_long_description": "Churning river offering 3 water channels with various rapid levels for tubing, surfing & kayaking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-2578-7596-9f27-104cb3b0f166.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-2578-7596-9f27-104cb3b0f166",
        "storage_key": "property/6767906449166986/019cfde4-2578-7596-9f27-104cb3b0f166.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.bendparksandrec.org/facility/bend-whitewater-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13239475215745249559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bend-whitewater-park",
      "poi_latitude": "44.0500556",
      "poi_longitude": "-121.3213198",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 541-389-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-4186-70ac-86fe-488cb7821ff7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-4186-70ac-86fe-488cb7821ff7",
        "storage_key": "property/6767906449166986/019cfde4-4186-70ac-86fe-488cb7821ff7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ53nNryzGuFQRF3EVH5AQvLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_75d99dc9e28ec483b8108c7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Pacific Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "200 NW Pacific Park Ln, Bend, OR 97701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-2577-768c-bced-bd8cf0e48ba2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-2577-768c-bced-bd8cf0e48ba2",
        "storage_key": "property/6767906449166986/019cfde4-2577-768c-bced-bd8cf0e48ba2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bendparksandrec.org/park/pacific-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6086497619626611041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pacific-park",
      "poi_latitude": "44.0628947",
      "poi_longitude": "-121.3122311",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 541-389-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-4186-70ac-86fe-488cb7821ff7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-4186-70ac-86fe-488cb7821ff7",
        "storage_key": "property/6767906449166986/019cfde4-4186-70ac-86fe-488cb7821ff7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ01mOjZ7IuFQRYdEaYFaVd1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_a33979842477718ab5b69c21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Pilot Butte State Scenic Viewpoint",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1310 NE Hwy 20, Bend, OR 97701, USA",
      "poi_short_description": "This area offering mountains & panoramic views of Bend can be accessed by car or by hiking trail.",
      "poi_long_description": "This area offering mountains & panoramic views of Bend can be accessed by car or by hiking trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-2905-7554-8392-bd58cc70a8e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-2905-7554-8392-bd58cc70a8e7",
        "storage_key": "property/6767906449166986/019cfde4-2905-7554-8392-bd58cc70a8e7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://oregonstateparks.org/index.cfm?do=parkPage.dsp_parkPage&parkId=33",
      "poi_directions_map_url": "https://maps.google.com/?cid=15652697874257090445&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pilot-butte-state-scenic-viewpoint",
      "poi_latitude": "44.0605432",
      "poi_longitude": "-121.2832425",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-551-6949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3dee-7398-a565-fcf284814efe",
        "storage_key": "property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfVahh5THuFQRjReb-8iNOdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_2c5aece99f305f93a6c11c28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Shevlin Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "18920 NW Shevlin Park Rd, Bend, OR 97701, USA",
      "poi_short_description": "A 652-acre preserve featuring extensive hiking & cross-country ski trails, fishing & picnic sites.",
      "poi_long_description": "A 652-acre preserve featuring extensive hiking & cross-country ski trails, fishing & picnic sites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-2a28-7473-98f7-727abd48a550.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-2a28-7473-98f7-727abd48a550",
        "storage_key": "property/6767906449166986/019cfde4-2a28-7473-98f7-727abd48a550.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bendparksandrec.org/park/shevlin-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17901887564600750748&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shevlin-park",
      "poi_latitude": "44.08316079999999",
      "poi_longitude": "-121.3779172",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 541-389-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-4186-70ac-86fe-488cb7821ff7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-4186-70ac-86fe-488cb7821ff7",
        "storage_key": "property/6767906449166986/019cfde4-4186-70ac-86fe-488cb7821ff7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNzW_rjbIuFQRnLICSeRHcPg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_61df665644a0024c463bac49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Hawthorne Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "334 NE Hawthorne Ave, Bend, OR 97701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-2b68-710f-9653-12fec00b1be6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-2b68-710f-9653-12fec00b1be6",
        "storage_key": "property/6767906449166986/019cfde4-2b68-710f-9653-12fec00b1be6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cascadeseasttransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14266496450052942475&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hawthorne-station",
      "poi_latitude": "44.058313",
      "poi_longitude": "-121.301313",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 541-385-8680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3dee-7398-a565-fcf284814efe",
        "storage_key": "property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY42opCHGuFQRi-rGJu_G_MU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "ec_fbf8d1a0bb1f780e96d35c65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Cascades East Transit - Bend Operations Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "1250 NE Bear Creek Rd, Bend, OR 97701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://cascadeseasttransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2957878979073227751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cascades-east-transit---bend-operations-center",
      "poi_latitude": "44.0531325",
      "poi_longitude": "-121.2876456",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 541-389-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3dee-7398-a565-fcf284814efe",
        "storage_key": "property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG85v4hbGuFQR5ztBjEJ_DCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_38b588fd3121986c9b34f422",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Cascades East Transit - Bend Operations Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "1250 NE Bear Creek Rd, Bend, OR 97701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://cascadeseasttransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2957878979073227751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cascades-east-transit---bend-operations-center",
      "poi_latitude": "44.0531325",
      "poi_longitude": "-121.2876456",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 541-389-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3dee-7398-a565-fcf284814efe",
        "storage_key": "property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG85v4hbGuFQR5ztBjEJ_DCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_366601a71165ff49e99f18ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Redmond Municipal Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2522 Jesse Butler Cir Suite 6, Redmond, OR 97756, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-2c93-7313-b172-cfb7ca7cd3aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-2c93-7313-b172-cfb7ca7cd3aa",
        "storage_key": "property/6767906449166986/019cfde4-2c93-7313-b172-cfb7ca7cd3aa.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.flyrdm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14530746548613734711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "redmond-municipal-airport",
      "poi_latitude": "44.253025",
      "poi_longitude": "-121.1608351",
      "poi_miles_from_property": "18.2 mi",
      "poi_walking_minutes": "6 hours 31 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 541-504-3499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-4544-752a-a220-6267a5b1594f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-4544-752a-a220-6267a5b1594f",
        "storage_key": "property/6767906449166986/019cfde4-4544-752a-a220-6267a5b1594f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJI8dU-Nkqv1QRN-Far_-Up8k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_c3ed06b1652d3d4d2e53d595",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Bend Municipal Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "63132 Powell Butte Rd, Bend, OR 97701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-2e40-7605-a681-8c815cfd8dbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-2e40-7605-a681-8c815cfd8dbd",
        "storage_key": "property/6767906449166986/019cfde4-2e40-7605-a681-8c815cfd8dbd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bendoregon.gov/government/departments/economic-development/bend-airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=3079490415602072642&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bend-municipal-airport",
      "poi_latitude": "44.0931852",
      "poi_longitude": "-121.2025894",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 541-389-0258",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-4544-752a-a220-6267a5b1594f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-4544-752a-a220-6267a5b1594f",
        "storage_key": "property/6767906449166986/019cfde4-4544-752a-a220-6267a5b1594f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3_LZGmHFuFQRQnwulzeMvCo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_abc7f23500a93e93d487abe6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "St. Charles Bend",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2500 NE Neff Rd, Bend, OR 97701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-153a-7135-9925-c32511e4144d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-153a-7135-9925-c32511e4144d",
        "storage_key": "property/6767906449166986/019cfde4-153a-7135-9925-c32511e4144d.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.stcharleshealthcare.org/locations/st-charles-bend?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=16519677801245240834&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-charles-bend",
      "poi_latitude": "44.06800390000001",
      "poi_longitude": "-121.269589",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 541-382-4321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-41c9-774d-9b46-be8a58d01f9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-41c9-774d-9b46-be8a58d01f9c",
        "storage_key": "property/6767906449166986/019cfde4-41c9-774d-9b46-be8a58d01f9c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJqQ8zPfjFuFQRAu4ga2-vQeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_ac529891d8ce5f5d201f4525",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Oregon State University-Cascades",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1500 SW Chandler Ave, Bend, OR 97702, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-0654-74ff-9a61-ef8ed8a3fa01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-0654-74ff-9a61-ef8ed8a3fa01",
        "storage_key": "property/6767906449166986/019cfde4-0654-74ff-9a61-ef8ed8a3fa01.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://osucascades.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17728967412679668300&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oregon-state-university-cascades",
      "poi_latitude": "44.0433055",
      "poi_longitude": "-121.334255",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 541-322-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3def-737f-9eca-4f397e3c1627",
        "storage_key": "property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeTv9UvbIuFQRTHI_A-7xCfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_3709a650073159c5227f258b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Central Oregon Community College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2600 NW College Way, Bend, OR 97703, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-0722-714c-812e-dab746a7f0ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-0722-714c-812e-dab746a7f0ea",
        "storage_key": "property/6767906449166986/019cfde4-0722-714c-812e-dab746a7f0ea.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.cocc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14323501484613636672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-oregon-community-college",
      "poi_latitude": "44.0676288",
      "poi_longitude": "-121.3470916",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 541-383-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3def-737f-9eca-4f397e3c1627",
        "storage_key": "property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeTv9UvbIuFQRQBItCrZMx8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_5a9ae5a7e821ec525b183207",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Bend-La Pine Schools",
      "poi_type": "Major Employers & Offices",
      "poi_address": "520 NW Wall St, Bend, OR 97703, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-2fb1-75d2-a9bd-d2c42a5c2665.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-2fb1-75d2-a9bd-d2c42a5c2665",
        "storage_key": "property/6767906449166986/019cfde4-2fb1-75d2-a9bd-d2c42a5c2665.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.bend.k12.or.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15553411941819902241&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bend-la-pine-schools",
      "poi_latitude": "44.05635059999999",
      "poi_longitude": "-121.3160779",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 541-355-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3def-737f-9eca-4f397e3c1627",
        "storage_key": "property/6767906449166986/019cfde4-3def-737f-9eca-4f397e3c1627.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH0Tv7YTIuFQRIWl-bcHR2Nc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_e95f267b519d7f3bc0e6bf29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Deschutes County Circuit Court",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1100 NW Bond St, Bend, OR 97703, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3052-7510-845a-56bbc74994ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-3052-7510-845a-56bbc74994ba",
        "storage_key": "property/6767906449166986/019cfde4-3052-7510-845a-56bbc74994ba.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://courts.oregon.gov/Deschutes/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2858790228205533015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deschutes-county-circuit-court",
      "poi_latitude": "44.0602869",
      "poi_longitude": "-121.3107219",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 541-388-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-45a1-717d-a76a-d76a0fab765c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-45a1-717d-a76a-d76a0fab765c",
        "storage_key": "property/6767906449166986/019cfde4-45a1-717d-a76a-d76a0fab765c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJucmb6p3IuFQRV3eM55B2rCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "ec_b5283336a584e168aa3bfabc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "City of Bend",
      "poi_type": "Major Employers & Offices",
      "poi_address": "710 NW Wall St, Bend, OR 97703, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-326e-773b-b938-d31ad6e5e25f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-326e-773b-b938-d31ad6e5e25f",
        "storage_key": "property/6767906449166986/019cfde4-326e-773b-b938-d31ad6e5e25f.webp",
        "width": 1280,
        "height": 487
      },
      "poi_business_url": "https://www.bendoregon.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5037382180733204669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-bend",
      "poi_latitude": "44.0570489",
      "poi_longitude": "-121.3150085",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 541-388-5505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-45a1-717d-a76a-d76a0fab765c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-45a1-717d-a76a-d76a0fab765c",
        "storage_key": "property/6767906449166986/019cfde4-45a1-717d-a76a-d76a0fab765c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV4WnKh3HuFQRvTh8eGdg6EU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_7e08448762a479ffd98a8575",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Les Schwab Tire Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "63590 N E Hunnell Rd, Bend, OR 97701, USA",
      "poi_short_description": "Chain tire store providing alignments, brake services, and repairs, plus batteries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3454-70c2-bcb6-43ddb59828da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-3454-70c2-bcb6-43ddb59828da",
        "storage_key": "property/6767906449166986/019cfde4-3454-70c2-bcb6-43ddb59828da.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.lesschwab.com/stores/or/bend/63590-hunnell-rd?utm_source=google&utm_medium=organic&utm_campaign=gmb-homepage",
      "poi_directions_map_url": "https://maps.google.com/?cid=806905984302637587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "les-schwab-tire-center",
      "poi_latitude": "44.1087263",
      "poi_longitude": "-121.301079",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 541-318-0281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3d85-75dc-a404-a197667aec02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3d85-75dc-a404-a197667aec02",
        "storage_key": "property/6767906449166986/019cfde4-3d85-75dc-a404-a197667aec02.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTansk9vOuFQRE-J-sbe0Mgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "auto_parts_store"
    },
    {
      "id": "ec_4a61ed0c7e2354d194bc891e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Summit Health",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1501 NE Medical Center Dr, Bend, OR 97701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-35d8-733a-a273-01da6dc60b07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfde4-35d8-733a-a273-01da6dc60b07",
        "storage_key": "property/6767906449166986/019cfde4-35d8-733a-a273-01da6dc60b07.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.smgoregon.com/bmc_clinics/bend-main-eastside-clinic/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8920993128531763387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "summit-health",
      "poi_latitude": "44.0649922",
      "poi_longitude": "-121.2673269",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 541-382-2811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3dee-7398-a565-fcf284814efe",
        "storage_key": "property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfZvLrf3FuFQRuyDWJfy7zXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_4a1f041c5bff24d29db4253f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "poi_name": "Lonza Bend",
      "poi_type": "Major Employers & Offices",
      "poi_address": "63060 NE Corporate Pl, Bend, OR 97701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.lonza.com/about-us/our-locations/bend-oregon-usa?utm_source=google&utm_medium=google-my-business&utm_campaign=sv-corp-google-Bend",
      "poi_directions_map_url": "https://maps.google.com/?cid=13526492824989755567&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lonza-bend",
      "poi_latitude": "44.0892603",
      "poi_longitude": "-121.2975294",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfde4-3dee-7398-a565-fcf284814efe",
        "storage_key": "property/6767906449166986/019cfde4-3dee-7398-a565-fcf284814efe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFcwgdTPPuFQRr2hi0o7Bt7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    }
  ],
  "office_hours": [
    {
      "id": "ec_f8197496bbd3849869124548",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3b5fbed4cb25fcbd9ebd4943",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_38729478ffe0c17dec482f7d",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d6b5e2833e32ac25437bccdd",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b532743344842d233f58b4fb",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_42273c49ef19356e7d131940",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_861d27bff2c9562e62a22dc0",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "day": "SUN",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_dd181c49fde04d04f1f7e3db",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "rating": "5",
      "name": "Alli Davis",
      "text": "Love this new apartment community! It is modern, clean, and in a great location. The layouts are well thought out and the amenities are actually useful. Tabatha is incredibly knowledgeable and made the experience easy and stress-free. You can tell she really knows the community and the area. Highly recommend checking it out!",
      "date": "2026-01-08",
      "title": "false"
    },
    {
      "id": "ec_2eb25a26866eff7146f04878",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "rating": "5",
      "name": "Casey Dragoo",
      "text": "I absolutely love living at Jackstraw Apartments! From the moment I moved in, everything has been top-notch. The apartments are modern, clean, and thoughtfully designed, with great natural light and high-quality finishes. Maintenance is incredibly responsive and always friendly—they fix issues quickly and do a great job every time.\n\nThe management team truly cares about residents and makes the community feel welcoming and well-run. The amenities are well maintained, and the location is super convenient, with easy access to shopping, dining, and everything I need.\n\nOverall, Jackstraw Apartments has exceeded my expectations, and I highly recommend it to anyone looking for a comfortable, stylish, and well-managed place to call home.",
      "date": "2026-01-09",
      "title": "false"
    },
    {
      "id": "ec_5de2004842b31d8b82f0f3e9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "rating": "5",
      "name": "Sean Oliver",
      "text": "I've lived here for a month so far and love it! Beautiful brand new apartment complex, from my unit to the common areas including a very nice gym and west-facing top floor lounge (with a working record player) overlooking the mountains. It's truly luxury quality throughout and a great place to call home. Perfect location right by Old Mill / Box Factory, grocery across the street, a short walk to downtown and ample parking for guests. Front office staff and maintenance are all so friendly and helpful. Highly recommend!",
      "date": "2025-12-17",
      "title": "false"
    },
    {
      "id": "ec_45e9e47b3d98e621ae0a001c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "rating": "5",
      "name": "Cole Bartlett",
      "text": "My wife, son and I stopped by the Jackstraw Fall Fest yesterday and wow, what a beautiful property! There’s truly nothing else like it in Bend. Everything exceeded our expectations, especially the staff. In particular, we got to tour a one-bedroom with the Nate (the property manager) and he was very friendly and informative about all the amenities that the property has to offer. He even took time to interact and share some laughs with our 15 month-old son, which meant a lot to us. The apartment was beautiful and had a ton of space. The Sunset Speakeasy and the Supper Club on the 5th floor were awesome and offered great views of the city and the mountains. Also seems like there will be plenty of parking for residents and guests. Perfect walking location to Old Mill District, the river and plenty of food options. What more could you want?",
      "date": "2025-10-26",
      "title": "false"
    },
    {
      "id": "ec_d5b8de661c3ac5f2dd4ce953",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "rating": "5",
      "name": "Lindsey Johnson",
      "text": "The new Jackstraw apartments are STUNNING. The interior design and ambiance are incredible the amenities + location are great. The community spaces both indoor and outdoor are calming and comfortable with great views. Can't wait to spend more time here!",
      "date": "2025-10-30",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_45bd3714f686071710698847",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Virtual Tour 1",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/vbLpZZf5weU?source=180"
    },
    {
      "id": "ec_74b299e386ebd1333fbaaee8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde5-ad66-733e-b8a7-dc6c8de02fc8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and wooden floors",
        "public_id": "019cfde5-ad66-733e-b8a7-dc6c8de02fc8",
        "storage_key": "property/6767906449166986/019cfde5-ad66-733e-b8a7-dc6c8de02fc8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Virtual Tour 2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ffwbq1Stykw"
    },
    {
      "id": "ec_dd5530c274fbb87ca05ffd9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde5-ad64-741f-bcac-aed4bf631459.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with island and stainless steel appliances, open to living area.",
        "public_id": "019cfde5-ad64-741f-bcac-aed4bf631459",
        "storage_key": "property/6767906449166986/019cfde5-ad64-741f-bcac-aed4bf631459.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Virtual Tour 3",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=6ck2REU9M8j"
    },
    {
      "id": "ec_5ea2ba0b1ca01939b228814c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde5-ad99-72b5-8f73-5052ba4d40dc.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Hallway with doors and ceiling lights",
        "public_id": "019cfde5-ad99-72b5-8f73-5052ba4d40dc",
        "storage_key": "property/6767906449166986/019cfde5-ad99-72b5-8f73-5052ba4d40dc.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR, 2BA - 1,445SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=NBpUiHmHJyh"
    },
    {
      "id": "ec_27ec9ce8b27239ca1ee2e5f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde5-ad71-7127-8178-f7f1b78a7266.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Hallway leading to living area with a closet",
        "public_id": "019cfde5-ad71-7127-8178-f7f1b78a7266",
        "storage_key": "property/6767906449166986/019cfde5-ad71-7127-8178-f7f1b78a7266.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 710SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Zk2yiyaUrgV"
    },
    {
      "id": "ec_66896b5535115ae0484f69bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde5-b53a-75ed-9947-3fa81fe750b9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with white cabinets, island with sink, and large window overlooking the city.",
        "public_id": "019cfde5-b53a-75ed-9947-3fa81fe750b9",
        "storage_key": "property/6767906449166986/019cfde5-b53a-75ed-9947-3fa81fe750b9.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "1BR, 1BA - 688SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ezPisqTikpJ"
    },
    {
      "id": "ec_141ceb3aa43f3c919e91d66d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde5-b573-76bb-88bb-e99e0bc0a6ad.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Interior hallway view of a modern apartment with a digital thermostat on the wall.",
        "public_id": "019cfde5-b573-76bb-88bb-e99e0bc0a6ad",
        "storage_key": "property/6767906449166986/019cfde5-b573-76bb-88bb-e99e0bc0a6ad.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 612SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=39GRvj8FTRA"
    },
    {
      "id": "ec_276c6d33f2777abe27975b0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde5-b59d-75d9-9b87-1c25703df00f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Interior of a modern lounge with stylish seating and a unique ceiling installation.",
        "public_id": "019cfde5-b59d-75d9-9b87-1c25703df00f",
        "storage_key": "property/6767906449166986/019cfde5-b59d-75d9-9b87-1c25703df00f.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Lobby",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=y3UFfhd2DoX"
    }
  ],
  "faqs": [
    {
      "id": "custom_4e7510f6-b185-4bef-8c9f-57b751b7a6b4",
      "question": "Who let the dogs out?",
      "answer": "WHO WHO WHO",
      "category": "false",
      "source": "custom"
    },
    {
      "id": "custom_1dd473ef-6e4b-42c7-a1ec-2c80a9c8c63b",
      "question": "Best type of dog?",
      "answer": "Corn dog",
      "category": "false",
      "source": "custom"
    }
  ],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "in-home-washer-dryer-bend-or",
      "search_query": "apartments with in-home washer and dryer Bend OR",
      "category": "Amenity",
      "h1_title": "Apartments with In-Home Washer and Dryer",
      "h2_subtitle": "Discover our Bend, OR apartments, featuring modern in-home washer and dryer amenities. Enjoy the relaxed lifestyle you deserve at Jackstraw Apartments.",
      "page_copy": "Welcome to Jackstraw Apartments, where modern conveniences meet stylish living in Bend, OR. Finding apartments with in-home washer and dryer facilities can enhance your daily routine, and we offer precisely that comfort. Situated in Deschutes County, each of our studios to three-bedroom apartments ensures you have access to the essential amenities that make home life so much easier.\n\nAt Jackstraw Apartments, you'll find more than just a fantastic location in Southern Crossing. Our community offers a range of features, from private patios with mountain views to a fitness center and even a dishwasher in each unit, complementing your in-home washer and dryer. Discover the ease and comfort of living in a thoughtfully designed apartment, perfect for your lifestyle. We invite you to tour our community and see why so many are choosing Jackstraw Apartments as their home in Bend, OR.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bend OR Apts with In-Home Washer & Dryer",
      "seo_description": "Enjoy Bend, OR living with in-home washer and dryers at Jackstraw Apartments. Perfect comfort awaits with modern conveniences and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "luxury-air-conditioned-apartments-southern-crossing",
      "search_query": "luxury air-conditioned apartments Southern Crossing",
      "category": "Amenity",
      "h1_title": "Luxury A/C Apartments in Southern Crossing",
      "h2_subtitle": "Experience ultimate comfort in our Southern Crossing luxury apartments with air conditioning. Unwind and relax at Jackstraw Apartments today.",
      "page_copy": "Jackstraw Apartments invites you to experience the pinnacle of comfort with our luxury air-conditioned apartments located in the vibrant Southern Crossing neighborhood. Nestled in the heart of Bend, OR, our apartments provide a sanctuary from the summer heat, keeping you cool and comfortable. Whether you prefer a cozy studio or a spacious three-bedroom layout, each apartment offers the modernity of air conditioning, ensuring a pleasant atmosphere all year round.\n\nLiving in Southern Crossing has its perks, and residing at Jackstraw Apartments elevates that experience with access to top-tier amenities. Our residents enjoy private patios with scenic Cascade Mountain views, a well-equipped fitness center, and a dishwasher in every kitchen. With a focus on comfort and convenience, our air-conditioned apartments offer a luxurious lifestyle tailored to your needs. Explore what makes Jackstraw Apartments the ideal choice for luxury living in Bend, OR.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Southern Crossing Luxury A/C Apartments",
      "seo_description": "Discover luxury living in Southern Crossing with air-conditioned apartments at Jackstraw. Enjoy style and comfort in the heart of Bend, OR.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "apartments-fitness-center-deschutes-county",
      "search_query": "apartments with fitness center Deschutes County",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center Access",
      "h2_subtitle": "Explore Deschutes County living with our apartments featuring a state-of-the-art fitness center. Elevate your lifestyle at Jackstraw Apartments.",
      "page_copy": "At Jackstraw Apartments in scenic Bend, OR, prioritize your health and fitness with access to our top-notch fitness center. Nestled in the desirable Deschutes County, Jackstraw Apartments offers a well-rounded community experience with amenities that promote a healthy lifestyle. Choose from our variety of floor plans, from cozy studios to spacious three-bedroom offerings, all within reach of the area's attractions.\n\nOur fitness center is just one of the many amenities designed to enhance your living experience. Residents can also enjoy private patios with impressive Cascade Mountain views and kitchens equipped with dishwashers. Located in the vibrant Southern Crossing neighborhood, Jackstraw Apartments provides a blend of modern comfort and convenience without compromising on luxury. If you're seeking an apartment where fitness is part of your daily routine, look no further than our community, the ideal choice for active living in Deschutes County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Deschutes County Apts with Fitness Center",
      "seo_description": "Live in Deschutes County with access to a fitness center at Jackstraw Apartments. Discover active, modern living in Bend, OR.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "pet-friendly-private-patios-bend",
      "search_query": "pet-friendly apartments with private patios Bend",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Patios",
      "h2_subtitle": "Discover our pet-friendly apartments in Bend, offering private patios perfect for you and your furry friend. Welcome to Jackstraw Apartments!",
      "page_copy": "At Jackstraw Apartments, we understand that pets are family, which is why we offer pet-friendly apartments with private patios in beautiful Bend, OR. Set in the charming Southern Crossing neighborhood, our community provides the ideal opportunity for you and your pets to enjoy the outdoors right from the comfort of your home. With a range of apartments, from cozy studios to expansive three-bedroom units, each features a private patio where you can relax with your furry friend.\n\nOur apartments are designed to accommodate modern living needs with amenities like a fitness center and a kitchen complete with a dishwasher. Enjoy the serenity of Cascade Mountain views from your private outdoor space, further enhancing your living experience. Jackstraw Apartments is your ultimate destination for pet-friendly living combined with convenience and comfort in Bend. Embrace the lifestyle you and your pet deserve by making Jackstraw your new home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apts with Patios in Bend",
      "seo_description": "Enjoy pet-friendly living in Bend with private patios at Jackstraw Apartments. Discover comfortable, modern spaces for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "opulent-cascade-mountain-view-apartments-97702",
      "search_query": "opulent Cascade Mountain view apartments 97702",
      "category": "Amenity",
      "h1_title": "Opulent Apartments with Mountain Views",
      "h2_subtitle": "Find opulent living with stunning Cascade Mountain views in the 97702 area. Welcome to Jackstraw Apartments, where luxury meets nature.",
      "page_copy": "Experience unparalleled luxury at Jackstraw Apartments, where opulence meets breathtaking Cascade Mountain views in the heart of Bend's 97702 area. Our community offers stylish living spaces ranging from elegant studios to lavish three-bedroom apartments, all designed to provide panoramic vistas that capture the essence of Bend's natural beauty. Revel in the grandeur of mountain living while enjoying all the comforts of modern amenities.\n\nEach apartment is thoughtfully appointed with features such as private patios, ensuring you always have a front-row seat to the majestic mountains. Beyond the views, our community is equipped with a state-of-the-art fitness center, making it easy for residents to maintain an active lifestyle. Situated in the desirable Southern Crossing neighborhood, Jackstraw Apartments is where opulence and natural beauty converge, offering a truly unique living experience in Bend, OR.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Opulent Mountain View Apts in Bend 97702",
      "seo_description": "Discover opulent living with Cascade Mountain views in Bend's 97702 area at Jackstraw Apartments. Luxury meets nature at its best.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "studio-apartments-bend-or-jackstraw",
      "search_query": "studio apartments Bend OR",
      "category": "Floorplan",
      "h1_title": "Stylish Studio Apartments in Bend, OR",
      "h2_subtitle": "Explore modern studio apartments at Jackstraw Apartments in Bend, OR. Perfect for comfortable and convenient living.",
      "page_copy": "Discover the perfect blend of style and function with our studio apartments at Jackstraw Apartments in Bend, OR. Nestled in the vibrant Southern Crossing neighborhood, our studios offer the ideal living space for those seeking modern amenities and a cozy atmosphere. Each studio is designed to maximize space and comfort, featuring chic interiors and ample natural light.\n\nOur community ensures residents have access to excellent amenities, including a fully-equipped fitness center and private offices, ideal for work or study. Step outside your studio onto a private patio and enjoy the serene views of the Cascade Mountains. With a central location and contemporary design, Jackstraw Apartments provides the perfect studio living experience in Bend, OR. Come and see why our studio apartments are the optimal choice for solo living or as your first home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Bend, OR",
      "seo_description": "Discover stylish studio apartments at Jackstraw Apartments in Bend, OR. Enjoy comfortable living with modern amenities and stunning mountain views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-southern-crossing",
      "search_query": "1 bedroom apartments Southern Crossing",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Southern Crossing",
      "h2_subtitle": "Discover spacious 1 bedroom apartments in Southern Crossing at Jackstraw Apartments. Perfectly designed for comfortable living and modern convenience.",
      "page_copy": "Welcome to Jackstraw Apartments, where our one-bedroom apartments in the Southern Crossing neighborhood of Bend, OR offer the perfect balance of comfort and style. These thoughtfully designed units provide ample living space, making them ideal for singles or couples looking to enjoy modern living in a vibrant community.\n\nOur one-bedroom apartments feature contemporary finishes and amenities, including private patios where you can take in the scenic views of the Cascade Mountains. With on-site conveniences like a fitness center and property management, your living experience is both relaxed and hassle-free. Located in the heart of Southern Crossing, Jackstraw Apartments offers easy access to social and recreational activities, elevating your lifestyle in Bend, OR.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments Southern Crossing",
      "seo_description": "Find spacious 1 bedroom apartments in Southern Crossing at Jackstraw Apartments. Experience modern convenience in Bend, OR.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-deschutes-county",
      "search_query": "2 bedroom apartments Deschutes County",
      "category": "Floorplan",
      "h1_title": "Spacious 2 Bedroom Apartments in Deschutes",
      "h2_subtitle": "Explore beautiful 2 bedroom apartments at Jackstraw Apartments in Deschutes County. Perfect for families or roommates seeking luxurious living.",
      "page_copy": "Discover the epitome of comfort and style with our two-bedroom apartments at Jackstraw Apartments, located in scenic Deschutes County, Bend, OR. Designed to meet a variety of needs, these spacious units offer the ideal living environment for families or roommates who value both privacy and togetherness.\n\nOur two-bedroom apartments feature contemporary design elements and amenities, including modern kitchens with dishwashers and private patios boasting stunning Cascade Mountain views. Community amenities like an on-site fitness center and private offices enhance the convenience and luxury of living at Jackstraw Apartments. Located in the sought-after Southern Crossing neighborhood, these apartments provide easy access to all Bend has to offer, making it a perfect place to call home in Deschutes County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious 2 Bedroom Apartments Deschutes",
      "seo_description": "Find spacious 2 bedroom apartments in Deschutes County at Jackstraw Apartments. Ideal for luxurious living in scenic Bend, OR.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-near-97702",
      "search_query": "3 bedroom apartments near 97702",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near 97702",
      "h2_subtitle": "Discover roomy 3 bedroom apartments at Jackstraw Apartments, conveniently located near the 97702 ZIP code. Ideal for families.",
      "page_copy": "If you're seeking a spacious living solution near the 97702 area, Jackstraw Apartments offers luxurious three-bedroom apartments designed for your family's comfort. Situated in the vibrant Southern Crossing neighborhood of Bend, OR, our community combines modern conveniences with a serene atmosphere, ideal for settling down or expanding your lifestyle.\n\nEach three-bedroom apartment is equipped with premium amenities, such as a modern kitchen with a dishwasher, a fitness center for all your workout needs, and private patios where you can savor the stunning Cascade Mountain views. Our on-site property management ensures a seamless living experience, making it easy to enjoy the surrounding beauty and accessibility of Bend. Experience the perfect balance of comfort and convenience with our three-bedroom offerings near the 97702 ZIP code.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near 97702",
      "seo_description": "Explore roomy 3 bedroom apartments near 97702 at Jackstraw Apartments. Ideal family living in Bend, OR with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "apartments-near-amity-creek-magnet-thompson-school",
      "search_query": "apartments near Amity Creek Magnet at Thompson School Bend",
      "category": "School",
      "h1_title": "Apartments Near Amity Creek Magnet School",
      "h2_subtitle": "Find perfect apartments close to Amity Creek Magnet at Thompson School in Bend. Enjoy family-friendly living at Jackstraw Apartments.",
      "page_copy": "Welcome to Jackstraw Apartments, where you can find the perfect home conveniently located near Amity Creek Magnet at Thompson School in Bend, OR. Our community in the Southern Crossing neighborhood offers an ideal setting for families who value education and connectivity, with proximity to esteemed schools and local attractions.\n\nAt Jackstraw Apartments, we offer modern living solutions ranging from stylish studios to spacious three-bedroom apartments. Each unit is designed with comfort and practicality in mind, featuring amenities like fully-equipped kitchens, private patios, and on-site facilities such as a fitness center. Enjoy the best of both worlds—access to quality educational institutions like Amity Creek Magnet at Thompson School and the vibrant lifestyle that Bend has to offer. Discover why Jackstraw Apartments is the ideal community for families seeking both convenience and a supportive environment near educational resources.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Amity Creek Magnet School Bend",
      "seo_description": "Find family-friendly apartments near Amity Creek Magnet School in Bend at Jackstraw Apartments. Modern living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "rentals-near-bear-creek-elementary-southern-crossing",
      "search_query": "rentals close to Bear Creek Elementary School in Southern Crossing",
      "category": "School",
      "h1_title": "Rentals near Bear Creek Elementary",
      "h2_subtitle": "Discover rentals close to Bear Creek Elementary School, located in the Southern Crossing neighborhood at Jackstraw Apartments.",
      "page_copy": "Looking for rentals with unbeatable proximity to Bear Creek Elementary School? Jackstraw Apartments in Bend's Southern Crossing neighborhood offers just that. Our community provides families with an opportunity to live near one of the area's esteemed schools, balancing educational convenience with a comfortable living environment.\n\nJackstraw Apartments features a variety of floor plans, from cozy studios to expansive three-bedroom units, all designed with modern amenities. Residents enjoy benefits such as fully-equipped kitchens, private patios, and a fitness center. Nestled in a scenic setting with breathtaking views of the Cascade Mountains, our community extends an inviting atmosphere for families. Choose Jackstraw Apartments for a harmonious blend of location, style, and quality that enhances your family's lifestyle while keeping you close to Bear Creek Elementary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals near Bear Creek Elementary in Bend",
      "seo_description": "Find rentals close to Bear Creek Elementary School at Jackstraw Apartments in Bend's Southern Crossing. Ideal family living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "jackstraw-apartments-highland-magnet-school-des",
      "search_query": "Jackstraw Apartments by Highland Magnet School at Kenwood Deschutes County",
      "category": "School",
      "h1_title": "Jackstraw Apartments by Highland Magnet School",
      "h2_subtitle": "Live near Highland Magnet School at Kenwood. Enjoy family-friendly living in Deschutes County at Jackstraw Apartments with exceptional amenities.",
      "page_copy": "Positioned conveniently in Deschutes County, Jackstraw Apartments offers an inviting living experience ideal for families looking to reside near educational landmarks like Highland Magnet School at Kenwood. Nestled in the vibrant Southern Crossing neighborhood of Bend, OR, our community provides a perfect blend of comfort and accessibility, making it a prime choice for families.\n\nAt Jackstraw Apartments, choose from diverse floor plans including stylish studios and spacious three-bedroom units. Revel in modern amenities designed to elevate your daily living, such as fully-equipped kitchens with dishwashers, private patios offering stunning Cascade Mountain views, and a welcoming fitness center. Our attentive on-site property management ensures a seamless living experience. Discover how Jackstraw Apartments provides the optimal living environment close to Highland Magnet School at Kenwood, where both education and lifestyle are prioritized.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Jackstraw Apartments by Highland Magnet School",
      "seo_description": "Live at Jackstraw Apartments near Highland Magnet School at Kenwood in Deschutes County. Family-friendly living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "lodging-near-westside-village-magnet-school-bend",
      "search_query": "lodging near Westside Village Magnet School at Kingston Elementary Bend",
      "category": "School",
      "h1_title": "Lodging Near Westside Village Magnet School",
      "h2_subtitle": "Explore exceptional lodging near Westside Village Magnet School at Kingston Elementary, situated in the charming Jackstraw Apartments.",
      "page_copy": "Jackstraw Apartments offers an ideal lodging option for those seeking proximity to Westside Village Magnet School at Kingston Elementary in Bend. Conveniently located in the scenic Southern Crossing neighborhood, our apartments are perfect for families and professionals alike, providing easy access to educational and local attractions.\n\nOur community features a selection of floor plans, ranging from chic studios to expansive three-bedroom layouts, all designed with your comfort in mind. Residents at Jackstraw Apartments enjoy modern amenities, including fully-equipped kitchens, a fitness center, and private patios with breathtaking views of the Cascade Mountains. Whether you're here for a short stay or settling in long-term, Jackstraw Apartments offers a welcoming environment that blends convenience and quality living near Westside Village Magnet School at Kingston Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lodging Near Westside Village School Bend",
      "seo_description": "Find perfect lodging near Westside Village Magnet School at Kingston Elementary in Bend at Jackstraw Apartments. Modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "rent-close-to-bend-senior-high-bend-or",
      "search_query": "rent close to Bend Senior High School Bend OR",
      "category": "School",
      "h1_title": "Rent Close to Bend Senior High School",
      "h2_subtitle": "Discover renting options close to Bend Senior High School. Experience convenient living in Bend, OR at Jackstraw Apartments.",
      "page_copy": "If you're searching for rent close to Bend Senior High School, Jackstraw Apartments is the perfect community for you. Situated in the vibrant Southern Crossing neighborhood of Bend, OR, our location offers convenient access to the school while providing a serene living environment surrounded by the stunning beauty of the Cascade Mountains.\n\nAt Jackstraw Apartments, choose from a range of floor plans, from cozy studios to roomy three-bedroom homes, tailored for your comfort. Our residents enjoy a variety of modern amenities including a fitness center, kitchens with dishwashers, and private patios perfect for relaxation. Managed by a professional on-site team, we ensure a quality living experience close to all the essential destinations like Bend Senior High School, making it a perfect choice for students and families alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rent Close to Bend Senior High School",
      "seo_description": "Rent near Bend Senior High School in Bend, OR at Jackstraw Apartments. Enjoy modern living in a convenient location with stunning mountain views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "apartments-near-marshall-high-school-deschutes",
      "search_query": "apartments by Marshall High School Deschutes County",
      "category": "School",
      "h1_title": "Apartments by Marshall High School",
      "h2_subtitle": "Find ideal apartments by Marshall High School. Jackstraw Apartments offers comfortable living in Deschutes County.",
      "page_copy": "Jackstraw Apartments provides a perfect home base for those wanting proximity to Marshall High School in Deschutes County. Located in the picturesque Southern Crossing neighborhood of Bend, OR, residents enjoy both the convenience of city living and the tranquility of nature with breathtaking Cascade Mountain views.\n\nOur community offers a variety of floor plans to suit your needs—from modern studios to spacious three-bedroom homes. Residents benefit from a suite of amenities, including a fitness center, modern kitchens equipped with dishwashers, and private patios. The on-site property management ensures a seamless living experience, making Jackstraw Apartments the ideal choice for families or individuals wishing to live near Marshall High School while enjoying everything that Deschutes County has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Marshall High School",
      "seo_description": "Discover comfy apartments near Marshall High School in Deschutes County at Jackstraw Apartments. Enjoy modern living with convenient school access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "apartments-near-osu-cascades-bend",
      "search_query": "apartments near Oregon State University-Cascades Bend",
      "category": "School",
      "h1_title": "Apartments Near OSU-Cascades Bend",
      "h2_subtitle": "Explore apartments near Oregon State University-Cascades in Bend. Jackstraw Apartments offers ideal student and staff living solutions.",
      "page_copy": "Located just a short drive from Oregon State University-Cascades, Jackstraw Apartments is the perfect spot for students, faculty, and staff seeking convenient housing in Bend. Our community in Southern Crossing provides an idyllic blend of academic access and leisure, surrounded by panoramic views of the Cascade Mountains.\n\nOur range of floor plans makes Jackstraw Apartments a versatile choice for singles and families alike, offering both studio and three-bedroom options. Residents enjoy a maintenance-free lifestyle with access to a modern fitness center, fully-equipped kitchens, and private outdoor spaces. With a property manager on-site, you'll find the support you need right away. Make the most of your university experience with Jackstraw Apartments' close proximity to campus and enjoy all that Bend has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near OSU-Cascades Bend",
      "seo_description": "Find apartments near OSU-Cascades in Bend at Jackstraw Apartments. Ideal for students and staff looking for modern, comfortable living options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "housing-near-central-oregon-community-college",
      "search_query": "housing close to Central Oregon Community College OR",
      "category": "School",
      "h1_title": "Housing Close to Central Oregon Community College",
      "h2_subtitle": "Discover housing options close to Central Oregon Community College. Jackstraw Apartments offers a perfect blend of comfort and convenience in Bend, OR.",
      "page_copy": "Jackstraw Apartments presents an excellent choice for those seeking housing close to Central Oregon Community College. Nestled in Bend's vibrant Southern Crossing neighborhood, our community combines practical living with breathtaking views of the Cascade Mountains, ensuring a rewarding lifestyle for students and staff alike.\n\nOffering diverse living arrangements—from cozy studios to expansive three-bedroom units—Jackstraw Apartments caters to the needs of all residents. Enjoy a range of premium amenities, such as a modern fitness center, well-appointed kitchens, and tranquil private patios. With an on-site property manager dedicated to creating a seamless living experience, you'll find our community provides the perfect home base near Central Oregon Community College while enjoying everything Deschutes County has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Central Oregon Community College",
      "seo_description": "Explore Jackstraw Apartments for housing near Central Oregon Community College in OR. Enjoy modern living with a convenient college proximity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "apartments-near-st-charles-bend-hospital",
      "search_query": "apartments near St. Charles Bend hospital Bend OR",
      "category": "Hospital",
      "h1_title": "Apartments Near St. Charles Bend Hospital",
      "h2_subtitle": "Find convenient apartments near St. Charles Bend Hospital. Jackstraw Apartments offers ideal accommodations in Bend, OR.",
      "page_copy": "For those seeking comfortable accommodations near St. Charles Bend Hospital, Jackstraw Apartments provides a prime location in Bend, OR. Situated in the Southern Crossing neighborhood, our community offers easy access to both essential healthcare services and the stunning natural beauty of the Cascade Mountains.\n\nResidents at Jackstraw Apartments can select from an array of living spaces, including studios and three-bedroom options, designed to match various lifestyle needs. Our suite of amenities includes a modern fitness center, fully-equipped kitchens, and serene private patios, ensuring a complete living experience. With an attentive property manager on site, you are assured of a hassle-free living environment. Whether you're a healthcare professional or simply wish to be close to St. Charles Bend Hospital, Jackstraw Apartments is the ideal place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near St. Charles Bend Hospital",
      "seo_description": "Discover Jackstraw Apartments near St. Charles Bend Hospital in OR. Enjoy modern facilities and convenient access to healthcare services.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "apartments-near-drake-park-bend",
      "search_query": "apartments near Drake Park in Bend",
      "category": "Park",
      "h1_title": "Apartments Near Drake Park Bend",
      "h2_subtitle": "Explore apartments near Drake Park in Bend, OR. Jackstraw Apartments offers modern living with natural beauty just steps away.",
      "page_copy": "Nestled in the vibrant city of Bend, Jackstraw Apartments offers an ideal location for those looking to reside near the picturesque Drake Park. Our community in Southern Crossing is perfectly situated to provide easy access to the park's scenic trails and recreational spaces, allowing residents to enjoy outdoor activities throughout the year.\n\nAt Jackstraw Apartments, choose from a selection of stylish studio and spacious three-bedroom layouts. Our amenities include a state-of-the-art fitness center, fully-equipped kitchens, and inviting private patios, providing the perfect blend of indoor comfort and outdoor leisure. With a dedicated property manager on site, you'll enjoy a seamless living experience. Make the most of your time in Bend by living near the beauty of Drake Park and experiencing the best of both nature and modern apartment living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Drake Park Bend",
      "seo_description": "Find your home at Jackstraw Apartments near Drake Park in Bend, OR. Experience modern amenities and access to beautiful outdoor spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "apartments-near-riverbend-park-southern-crossing",
      "search_query": "apartments close to Riverbend Park Southern Crossing",
      "category": "Park",
      "h1_title": "Apartments Close to Riverbend Park",
      "h2_subtitle": "Discover comfortable apartments close to Riverbend Park in Southern Crossing. Jackstraw Apartments offers a perfect location in Bend, OR.",
      "page_copy": "Located conveniently in Bend's Southern Crossing neighborhood, Jackstraw Apartments provides the perfect home for those seeking proximity to Riverbend Park. Just a short stroll away, Riverbend Park offers a picturesque escape along the Deschutes River, ideal for relaxing, kayaking, or enjoying scenic walks.\n\nJackstraw Apartments offers a range of accommodating options, from cozy studios to spacious three-bedroom layouts. Our modern amenities, including a fitness center, private patios, and sleek kitchens, ensure a comfortable and fulfilling living experience. Managed by an attentive on-site property manager, our community is designed to meet the needs of modern living while keeping you close to the natural beauty of Riverbend Park. Experience the best of Bend living at Jackstraw Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Riverbend Park",
      "seo_description": "Live near Riverbend Park in Bend, OR at Jackstraw Apartments. Enjoy modern living with nearby river access and beautiful park views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "apartments-by-farewell-bend-park-deschutes-county",
      "search_query": "apartments by Farewell Bend Park Deschutes County",
      "category": "Park",
      "h1_title": "Apartments by Farewell Bend Park",
      "h2_subtitle": "Explore apartments by Farewell Bend Park in Deschutes County. Jackstraw Apartments offers a convenient and scenic living experience.",
      "page_copy": "Imagine waking up every day just moments away from the beautiful Farewell Bend Park in Deschutes County. Located in Bend’s Southern Crossing neighborhood, Jackstraw Apartments offers an unmatched living experience for those who appreciate proximity to nature's wonders. Bask in the park's breathtaking river views and enjoy relaxing walks or thrilling outdoor adventures.\n\nAt Jackstraw Apartments, residents can choose from a variety of well-designed studio and three-bedroom layouts, each featuring modern amenities such as a full kitchen, fitness center, and private patios. The on-site property manager ensures a seamless and enjoyable living experience, keeping you close to the tranquility of Farewell Bend Park while providing the comforts of modern apartment living. Jackstraw Apartments is more than just a place to live; it’s a community designed for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Farewell Bend Park",
      "seo_description": "Find your home at Jackstraw Apartments by Farewell Bend Park, Deschutes County. Enjoy modern living close to parks and recreational opportunities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "apartments-near-millers-landing-park-bend",
      "search_query": "apartments near Miller's Landing Park OR",
      "category": "Park",
      "h1_title": "Apartments Near Miller's Landing Park",
      "h2_subtitle": "Find perfectly located apartments near Miller's Landing Park in Bend, OR. Jackstraw Apartments combines comfort with scenic surroundings.",
      "page_copy": "Jackstraw Apartments, nestled in the heart of Bend, OR, offers an unparalleled living experience for those seeking apartments near Miller's Landing Park. Just minutes from the park, residents can easily enjoy kayaking, picnics, and leisurely walks along the picturesque Deschutes River, making it a perfect setting for nature lovers and active individuals.\n\nOur community boasts a variety of floor plans, from chic studios to roomy three-bedroom units, all featuring modern kitchens and private patios. The on-site fitness center and professional property management team ensure a hassle-free lifestyle for our residents. At Jackstraw Apartments, experience the ideal blend of adventure and tranquility while staying connected to the vibrant Bend community, all from the comfort of a home that truly suits your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Miller's Landing Park",
      "seo_description": "Discover Jackstraw Apartments near Miller's Landing Park, Bend, OR. Enjoy modern living with access to outdoor activities and river views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "apartments-close-to-mckay-park-bend-or",
      "search_query": "apartments close to McKay Park Bend OR",
      "category": "Park",
      "h1_title": "Apartments Close to McKay Park",
      "h2_subtitle": "Live in comfort near McKay Park in Bend, OR. Jackstraw Apartments offers a serene and convenient living experience just steps away.",
      "page_copy": "Discover a vibrant living community at Jackstraw Apartments, perfectly situated within walking distance of McKay Park in Bend, OR. With this prime location, enjoy easy access to the park's lovely river views, expansive green spaces, and recreational opportunities such as swimming and picnicking, ideal for both relaxation and adventure.\n\nOur apartments range from stylish studios to spacious three-bedroom layouts, each equipped with modern amenities like fully outfitted kitchens and private patios. With a fitness center and an on-site property manager, our community is committed to providing a hassle-free and enjoyable living experience. At Jackstraw Apartments, relish the perfect blend of nature and modern convenience, making it an ideal choice for anyone looking to embrace the vibrant lifestyle of Bend, OR.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to McKay Park Bend OR",
      "seo_description": "Find your ideal home near McKay Park at Jackstraw Apartments in Bend, OR. Enjoy modern amenities and close proximity to outdoor fun.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "apartments-nearby-bend-whitewater-park-97702",
      "search_query": "apartments nearby Bend Whitewater Park 97702",
      "category": "Park",
      "h1_title": "Apartments Nearby Bend Whitewater Park",
      "h2_subtitle": "Discover modern living in Bend, OR, nearby Bend Whitewater Park. Jackstraw Apartments offers convenience and adventure.",
      "page_copy": "Nestled in the vibrant Southern Crossing neighborhood, Jackstraw Apartments offers high-quality living just a stone's throw from Bend Whitewater Park. Residents benefit from immediate access to the park's exhilarating whitewater channel, ideal for kayaking and paddleboarding, along with opportunities for leisurely riverside strolls.\n\nChoose from our selection of designer studio to expansive three-bedroom apartments, boasting contemporary amenities such as well-equipped kitchens, scenic private patios, and a state-of-the-art fitness center. With an attentive on-site property manager, Jackstraw Apartments not only delivers comfort but also ensures a seamless living experience. Enjoy a dynamic Bend lifestyle with the natural beauty and thrill of the Bend Whitewater Park right at your doorstep in the 97702 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Nearby Bend Whitewater Park",
      "seo_description": "Live near Bend Whitewater Park at Jackstraw Apartments, 97702. Enjoy modern amenities and outdoor adventure just minutes away.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "apartments-near-pacific-park-bend",
      "search_query": "apartments near Pacific Park in Bend",
      "category": "Park",
      "h1_title": "Apartments Near Pacific Park Bend",
      "h2_subtitle": "Explore comfortable living near Pacific Park in Bend. Jackstraw Apartments offers modern amenities and a prime location.",
      "page_copy": "Experience the best of Bend living at Jackstraw Apartments, located conveniently near Pacific Park. This community offers the perfect balance of tranquility and excitement, with Pacific Park's beautiful open spaces and recreational activities just a short distance away.\n\nOur thoughtfully designed studios to three-bedroom apartments feature modern kitchens, private patios, and scenic views of the Cascade Mountains. Residents enjoy the convenience of an on-site fitness center and attentive property management that takes care of all your needs. At Jackstraw Apartments, you are not just renting an apartment, but stepping into a lifestyle of comfort and adventure amidst the lively spirit of Bend.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pacific Park Bend",
      "seo_description": "Discover Jackstraw Apartments near Pacific Park, Bend. Enjoy modern living with access to parklands and Cascade views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449166986",
      "source": "generator",
      "page_item_url": "apartments-close-to-shevlin-park-deschutes-county",
      "search_query": "apartments close to Shevlin Park Deschutes County",
      "category": "Park",
      "h1_title": "Apartments Close to Shevlin Park",
      "h2_subtitle": "Live near Shevlin Park in Deschutes County. Discover Jackstraw Apartments offering modern amenities and a serene setting.",
      "page_copy": "Located in the heart of Deschutes County, Jackstraw Apartments provides an ideal home base just a short drive from Shevlin Park. This proximity allows our residents to easily enjoy the park's breathtaking trails, pristine picnic spots, and lush natural beauty, perfect for outdoor enthusiasts and families alike.\n\nOur community features a range of apartment options from chic studios to spacious three-bedroom layouts, each designed with comfort and convenience in mind. Enjoy modern amenities such as fully equipped kitchens, private patios, and an elevator for easy access. Nestled in the Southern Crossing neighborhood, Jackstraw Apartments not only offers a tranquil living environment but also the excitement of nearby Shevlin Park's diverse recreational activities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
      "featured_image_media": {
        "alt_text": "View of mountains and town from a balcony",
        "public_id": "019cfde3-c96e-759f-8ec2-a58352d2e5e8",
        "storage_key": "property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp",
        "width": 1920,
        "height": 1283
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Shevlin Park",
      "seo_description": "Find your ideal home near Shevlin Park in Deschutes County at Jackstraw Apartments. Enjoy modern living with nature on your doorstep.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_audioeye_site_id",
      "type": "STRING",
      "value": "4cf1dea7-1c3a-404a-b286-db384d502663"
    },
    {
      "ID": "custom_audioeye_site_hash",
      "type": "STRING",
      "value": "f562d9982872721ce5212c940da8de70"
    }
  ],
  "custom_audioeye_site_id": "4cf1dea7-1c3a-404a-b286-db384d502663",
  "custom_audioeye_site_hash": "f562d9982872721ce5212c940da8de70"
};

export const generatedAt = '2026-10-05T18:29:32.479Z';
